/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
 *      1       | 09/02/2025 | Lic. José Luis Aragón Cervantes  | Creación
 *      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Prioridad localStorage en almacenes de traslado
 *      3       | 23/09/2026 | LIC. José Luis Aragón C.                       | Catálogo cbarras Redis + buffer
 *              |            |                                  | de captura (RequestContext/JWE)
 *      4       | 23/09/2026 | LIC. José Luis Aragón C.                       | Flush silencioso (sin loader ni
 *              |            |                                  | recarga) para autofinado periódico
 *      5       | 23/09/2026 | LIC. José Luis Aragón C.                       | Flush manda partidas en pantalla
 *              |            |                                  | + buffer (robusto sin Redis)
 *      6       | 23/09/2026 | LIC. José Luis Aragón C.                       | Finado previo en sincronizar/
 *              |            |                                  | nueva/guardar; EDITAR al finar;
 *              |            |                                  | borrado de buffer en partidas
 *      7       | 23/09/2026 | LIC. José Luis Aragón C.                       | Autofinado silencioso NO cambia
 *              |            |                                  | título (no congela el módulo)
 * ---------------------------------------------------------------------------------------
*/

import { createContext, useContext, useState, useEffect, useRef, useMemo } from "react";
import {
  resolverNombreImpresoraEtiqueta,
  guardarNombreImpresoraEtiqueta,
  validarEstadoImpresoraPrinterTools,
  listarImpresorasConEstado,
} from "../../settings/printerTools.js";
import {
  apiAplicarEntradaSalidaInventario,
  apiRegistrarArticuloSalidaInventario,
  apiRegistrarArticuloEntradaInventario,
  apiIncrementarFolioEntradas,
  apiIncrementarFolioSalidas,
  apiFolioDisponibleSalidas,
  apiFolioDisponibleEntradas,
  apiObtenerEntradasSalidas,
  apiObtenerListaAgrupadaEntradasSalidas,
  apiObtenerListaConceptosEntradas,
  apiObtenerListaConceptosSalidas,
  apiListaAlmacenesExhibidores,
  apiEliminarPartidaEntradaSalidaInventario,
  apiBuscarArticuloPorClaveMedida,
  apiObtenerReporteEntradasSalidas,
  apiStatusEntradaSalida,
  apiEliminarEntradaCompleta,
  apiEliminarSalidaCompleta,
  apiCancelarEntrada,
  apiCancelarSalida,
  apiFiltroExistenciasAlmacenExhibidor,
  apiFiltroExistenciasFull,
  apiKardexArticulos,
  apiTrasladosList,
  apiTrasladosRegistrar,
  apiTrasladosAplicar,
  apiTrasladosEliminaPartida,
  apiTrasladosEliminaTrasladoPC,
  apiImprimirTraslado,
  apiReporteTrasladosPeriodo,
  apiBuscarArticuloPorCodigoBarras,
  apiBuscarArticuloPorClave,
  apiIntegrarEtiquetadoInventario,
  apiLimpiarEtiquetado,
  apiUpdateEtiquetado,
  apiGetListEtiquetado,
  apiReporteEtiquetadoDiario,
  apiAgregarEtiquetado,
  apiEliminarPartidaEtiquetado,
  apiCambiarAlmacenEtiquetado,
  //Toma Inventarios
  apiTomaInventarioActivo,
  apiTomaInventarioCrearFolio,
  apiTomaInventarioGetHeader,
  apiTomaInventarioSaveHeader,
  apiTomaInventarioGetDetallePaginados,
  apiTomaInventarioSaveDetalle,
  apiTomaInventarioCargarGeneral,
  apiTomaInventarioAgregarArticulo,
  apiBuscarArticulosInventario,
  apiTomaInventarioImportarConteos,
  apiTomaInventarioValidarZonas,
  apiTomaInventarioFijarConteo,
  apiTomaInventarioCerrar,
  apiTomaInventarioAplicar,
  apiTomaInventarioCancelar,
  apiTomaInventarioPdf,
  apiTomaInventarioActualizarConteoAFijar,
  apiTomaInventarioEliminarArticulo,
  apiTomaInventarioEliminarTodo,
  apiTomaInventarioFijarTodoConteo,
  apiTomaInventarioReiniciarConteos,
  apiTomaInventarioReiniciarConteoArticulo,
  apiTomaInventarioEditarConteo3,
  apiTomaInventarioEliminarConteosEscaneo,
  apiTomaInventarioImportarConteosAConteosEscaneo,
  apiIngresoRapido,
  apiActualizarCantidadPartidaEntradaSalida,
  apiSincronizarExistenciasEntradas,
  apiSincronizarExistenciasFiltro,
  apiSincronizarExistenciaArticulo,
  apiValidarStock,
  apiSalidasCapturar,
  apiSalidasGuardarTemporales,
  apiEntradasGuardarTemporales,
  apiEntradasCatalogoCbarras,
  apiEntradasResolverCodigo,
  apiSalidasResolverCodigo,
  apiEntradasCapturar,
  apiEntradasCapturaLista,
  apiEntradasCapturaEliminarPartida,
  apiEntradasCapturaEliminarTodo,
  apiLimpiezaNuevo,
} from "../../settings/ApiConfig";

import { useNavigate } from "react-router-dom";

import {
  getDatePost,
  isErrorForm,
  isJsonString,
  isNullOrEmpty,
  handleValidarStrings,
  speakText,
} from "../../settings/utils";

import { defaultTypes } from "../../settings/enums";
import { useRequest } from "../System/RequestContext";
import { useSesion } from "../System/SesionContext";
import { useLayout } from "../../context/System/LayoutContext";
import { useReactToPrint } from "react-to-print";

import { tr } from "date-fns/locale";
import { DateTimeField } from "@mui/x-date-pickers";
import { dateTimeValue } from "docx";
import { set } from "date-fns";
import { PieChart } from "recharts";
import SalidasLocalService from "../../services/SalidasLocalService";
import EntradasLocalService from "../../services/EntradasLocalService";

const getDataEntradasSalidas = () => ({
  id: 0,
  folioentradasalida: "",
  statusentradasalida: "CA",
  conceptoentradasalida: "",
  clavearticulo: "",
  cantidadarticulo: 0,
  usuario: "",
  medida: 0,
  pmvb: 0,
  costoventa: 0,
  almacenexhibidor: "",
  fechaentradasalida: defaultTypes.Date,
});

const getDataArticuloEscaneado = () => ({
  clavearticulo: "",
  descripcion: "",
  existencia: 0,
  medida: 0,
  pmvb: 0,
  costoventa: 0,
  almacenexhibidor: "",
});

//modelos Toma Inventarios
const getDataTomaInventarioHeader = () => ({
  fecharegistro: null,
  folioinventario: 0,
  usuarioresponsable: "",
  totalzonas: 0,
  totalarticulos: 0,
  totalinventariados: 0,
  totalfaltantes: 0,
  articuloscondiferencias: 0,
  statusinventario: "PE",
  almacenexhibidor: "",
  tipoinventario: "GENERAL", // agregado para UI (no existe en tabla)
});

const getDataTomaInventarioDetalleRow = () => ({
  folioinventario: 0,
  claveArticulo: "",
  descripcion: "",
  medida: 0,
  conteo1: 0,
  conteo2: 0,
  conteo3: 0,
  conteoAFijar: 0, // 0 = sin fijar, el usuario selecciona después
  existencia: 0,
  statusConteo: "PE",
});

export const InventariosContext = createContext();
export const InventariosProvider = (props) => {
  const { GetRequest, PostRequest, PutRequest, DeleteRequest, GetFileRequest, PostFileRequest } = useRequest();
  const { parametrosCajaForm, usuario, tipoUsuario, token } = useSesion();
  const { handleOpenAlert, handleOpenLoader, handleCloseLoader } = useLayout();
  const navigation = useNavigate();

  // Variables derivadas con trim para evitar problemas de espacios
  const pcLimpia = (parametrosCajaForm?.caja || "").trim();
  const almacenDominio = (parametrosCajaForm?.dominio || "").trim();

  // Helper para obtener almacen desde localStorage (definido inline para evitar hoisting issues)
  const getStoredAlmacen = (key) => {
    try {
      const stored = localStorage.getItem(key);
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  };

  const getTrasladoAlmacenActual = (key) => {
    const stored = getStoredAlmacen(key);

    if (stored && typeof stored === "object" && stored.nombre) {
      return stored;
    }

    if (typeof stored === "string" && stored.trim()) {
      return { nombre: stored.trim() };
    }

    return null;
  };

  // Inicializar almacen desde localStorage
  const getInitialAlmacen = () => {
    try {
      const stored = localStorage.getItem('entrada_almacenExhibidor');
      return stored ? JSON.parse(stored) : "";
    } catch {
      return "";
    }
  };

  const getInitialAlmacenSalida = () => {
    try {
      const stored = localStorage.getItem('salida_almacenExhibidor');
      return stored ? JSON.parse(stored) : "";
    } catch {
      return "";
    }
  };

  const [dataEntradas, setDataEntradas] = useState(getDataEntradasSalidas());
  const [dataSalidas, setDataSalidas] = useState(getDataEntradasSalidas());
  const [articuloEscaneado, setArticuloEscaneado] = useState(
    getDataArticuloEscaneado()
  );

  const [conceptoEntrada, setConceptoEntrada] = useState(() => {
    try {
      const stored = localStorage.getItem('entrada_concepto');
      return stored ? JSON.parse(stored) : "";
    } catch {
      return "";
    }
  });

  const [conceptoSalida, setConceptoSalida] = useState(() => {
    try {
      const stored = localStorage.getItem('salida_concepto');
      return stored ? JSON.parse(stored) : "";
    } catch {
      return "";
    }
  });

  const [almacenExhibidor, setAlmacenExhibidor] = useState(() => {
    try {
      const stored = localStorage.getItem('entrada_almacenExhibidor');
      return stored ? JSON.parse(stored) : "";
    } catch {
      return "";
    }
  });
  const [almacenExhibidorSalida, setAlmacenExhibidorSalida] = useState(() => getInitialAlmacenSalida());
  const [listaEntradas, setListaEntradas] = useState([]);
  const [listaSalidas, setListaSalidas] = useState([]);

  const listaEntradasSalidas = useMemo(() => {
    return [...listaEntradas, ...listaSalidas];
  }, [listaEntradas, listaSalidas]);
  const [listaConceptosEntrada, setListaConceptosEntrada] = useState([]);
  const [listaConceptosSalida, setListaConceptosSalida] = useState([]);
  const [listaAlmacenesExhibidoresEntrada, setListaAlmacenesExhibidoresEntrada] = useState([]);
  const [listaAlmacenesExhibidoresSalida, setListaAlmacenesExhibidoresSalida] = useState([]);
  const [listaAlmacenesExhibidoresGeneral, setListaAlmacenesExhibidoresGeneral] = useState([]);
  const [folioEntrada, setFolioEntrada] = useState(0);
  const [folioSalida, setFolioSalida] = useState(0);
  const [totalPMVB, setTotalPMVB] = useState(0);
  const [totalCostoVenta, setTotalCostoVenta] = useState(0);
  const [totalVentaNeta, setTotalVentaNeta] = useState(0);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [cantidadArticulos, setCantidadArticulos] = useState(0);
  const [statusEntrada, setStatusEntrada] = useState("PENDIENTE");
  const [statusSalida, setStatusSalida] = useState("PENDIENTE");
  const [titleActionSave, setTitleActionSave] = useState("NUEVA");
  const [ventanaAbierta, setVentanaAbierta] = useState("");
  const [dataFiltroExistencias, setDataFiltroExistencias] = useState([]);
  const [listaExistencias, setListaExistencias] = useState([]);
  const [statusWaiting, setStatusWaiting] = useState(false);
  const [errorDestino, setErrorDestino] = useState(false);
  const [listaTrasladosData, setListaTrasladosData] = useState([]);
  const [isTrasladoBlocked, setIsTrasladoBlocked] = useState(true);

  const [almacenExhibidorOrigen, setAlmacenExhibidorOrigen] = useState(() => {
    const stored = getStoredAlmacen('traslado_almacenOrigen');
    if (stored?.nombre) return stored;
    const dominio = (parametrosCajaForm?.dominio || "").trim().toUpperCase();
    if (dominio) return { nombre: dominio };
    return null;
  });
  const [almacenExhibidorDestino, setAlmacenExhibidorDestino] = useState(() => getStoredAlmacen('traslado_almacenDestino'));

  useEffect(() => {
    if (almacenExhibidorOrigen) {
      localStorage.setItem('traslado_almacenOrigen', JSON.stringify(almacenExhibidorOrigen));
    } else {
      localStorage.removeItem('traslado_almacenOrigen');
    }
  }, [almacenExhibidorOrigen]);

  useEffect(() => {
    if (almacenExhibidorDestino) {
      localStorage.setItem('traslado_almacenDestino', JSON.stringify(almacenExhibidorDestino));
    } else {
      localStorage.removeItem('traslado_almacenDestino');
    }
  }, [almacenExhibidorDestino]);

  useEffect(() => {
    if (almacenExhibidor) {
      localStorage.setItem('entrada_almacenExhibidor', JSON.stringify(almacenExhibidor));
    }
  }, [almacenExhibidor]);

  useEffect(() => {
    if (almacenExhibidorSalida) {
      localStorage.setItem('salida_almacenExhibidor', JSON.stringify(almacenExhibidorSalida));
    }
  }, [almacenExhibidorSalida]);

  useEffect(() => {
    if (conceptoSalida) {
      localStorage.setItem('salida_concepto', JSON.stringify(conceptoSalida));
    }
  }, [conceptoSalida]);

  useEffect(() => {
    if (conceptoEntrada) {
      localStorage.setItem('entrada_concepto', JSON.stringify(conceptoEntrada));
    }
  }, [conceptoEntrada]);

  useEffect(() => {
    const listaActiva = listaEntradas.length > 0 ? listaEntradas : (listaSalidas.length > 0 ? listaSalidas : []);

    if (!listaActiva || listaActiva.length === 0) {
      setTotalRegistros(0);
      setCantidadArticulos(0);
      setTotalPMVB(0);
      setTotalCostoVenta(0);
      setTotalVentaNeta(0);
      return;
    }

    const totalRegs = listaActiva.length;
    const totalArticulos = listaActiva.reduce((sum, item) => {
      const cantidad = parseFloat(item.cantidadarticulo) || 0;
      return sum + cantidad;
    }, 0);
    const totalCostCompra = listaActiva.reduce((sum, item) => {
      const cantidad = parseFloat(item.cantidadarticulo) || 0;
      const costo = parseFloat(item.pmvb) || 0;
      return sum + (cantidad * costo);
    }, 0);
    const totalCostVenta = listaActiva.reduce((sum, item) => {
      const cantidad = parseFloat(item.cantidadarticulo) || 0;
      const costo = parseFloat(item.costoventa) || 0;
      return sum + (cantidad * costo);
    }, 0);
    const totalVenta = listaActiva.reduce((sum, item) => {
      const cantidad = parseFloat(item.cantidadarticulo) || 0;
      const venta = parseFloat(item.precioventa) || parseFloat(item.costoventa) || 0;
      return sum + (cantidad * venta);
    }, 0);

    setTotalRegistros(totalRegs);
    setCantidadArticulos(totalArticulos);
    setTotalPMVB(totalCostCompra);
    setTotalCostoVenta(totalCostVenta);
    setTotalVentaNeta(totalVenta);
  }, [listaEntradas, listaSalidas]);

  const [claveArticulo, setClaveArticulo] = useState("");
  const [medida, setMedida] = useState(0.0);

  const [openModal, setOpenModal] = useState(false);
  const [
    openModalImpresionEntradasSalidas,
    setOpenModalImpresionEntradasSalidas,
  ] = useState(false);
  const [statusModalBuscadorArticulos, setStatusModalBuscadorArticulos] =
    useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [openModarlBuscarEntradaSalida, setOpenModarlBuscarEntradaSalida] =
    useState(false);
  const [openModalBuscarArticulos, setOpenModalBuscarArticulos] =
    useState(false);
  const [openModalFirmaTraslados, setOpenModalFirmaTraslados] = useState(false);
  const [openModalValidarAcceso, setOpenModalValidarAcceso] = useState(false);
  const [openModalAlertaSinExistencia, setOpenModalAlertaSinExistencia] = useState(false);
  const [dataArticuloSinExistencia, setDataArticuloSinExistencia] = useState({});

  const [partidaTrasladoSeleccionada, setPartidaTrasladoSeleccionada] =
    useState({});

  const contentRef = useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const guardarTomaInventarioRef = useRef(false);
  const guardarImportarConteoRef = useRef(false);
  const eliminarConteoRef = useRef(false);

  // -------------------- TOMA INVENTARIO --------------------
  const [
    statusModalBuscadorArticulosTomaInventario,
    setStatusModalBuscadorArticulosTomaInventario,
  ] = useState(false);
  const [tomaHeader, setTomaHeader] = useState(getDataTomaInventarioHeader());
  const [tomaDetalle, setTomaDetalle] = useState([]);
  const [tomaZonasDiff, setTomaZonasDiff] = useState([]);

  // Paginación detalle Toma Inventario
  const [tomaDetallePage, setTomaDetallePage] = useState(1);
  const [tomaDetallePageSize, setTomaDetallePageSize] = useState(9);
  const [tomaDetalleTotalCount, setTomaDetalleTotalCount] = useState(0);
  const [tomaDetalleTotalPages, setTomaDetalleTotalPages] = useState(0);
  const [tomaDetalleFilter, setTomaDetalleFilter] = useState("");

  const [openModalTomaSelectivo, setOpenModalTomaSelectivo] = useState(false);
  const [openModalTomaImportar, setOpenModalTomaImportar] = useState(false);
  const [openModalTomaZonasDiff, setOpenModalTomaZonasDiff] = useState(false);

  const [tomaBuscadorQ, setTomaBuscadorQ] = useState("");
  const [tomaArticulosFound, setTomaArticulosFound] = useState([]);
  // ----------------------------------------------------------

  //Etiquetado
  const [dataArticuloEtiquetar, setDataArticuloEtiquetar] = useState([]);
  const [articuloEtiquetar, setArticuloEtiquetar] = useState({});
  const [articuloFiltro, setArticuloFiltro] = useState({});
  const [medidaEtiqueta, setMedidaEtiqueta] = useState(0);
  const [dataArticuloFiltroEtiquetado, setDataArticuloFiltroEtiquetado] =
    useState([]);
  const [cantidadesEtiquetado, setCantidadesEtiquetado] = useState({});
  const [integrarInventario, setIntegrarInventario] = useState(true);
  const [almacenExhibidorEtiquetado, setAlmacenExhibidorEtiquetado] = useState("");

  useEffect(() => {
    const stored = localStorage.getItem('etiquetado_integrarInventario');
    if (stored !== null) {
      setIntegrarInventario(stored === 'true');
    } else {
      setIntegrarInventario(true);
    }
  }, []);

  useEffect(() => {
    if (dataArticuloEtiquetar.length === 0) {
      setIntegrarInventario(true);
      localStorage.setItem('etiquetado_integrarInventario', 'true');
    }
  }, [dataArticuloEtiquetar]);

  useEffect(() => {
    localStorage.setItem('etiquetado_integrarInventario', String(integrarInventario));
  }, [integrarInventario]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('etiquetado_almacenExhibidor');
      if (stored && stored !== "null" && stored.trim() !== "") {
        setAlmacenExhibidorEtiquetado(stored);
      } else if (parametrosCajaForm?.dominio) {
        setAlmacenExhibidorEtiquetado(parametrosCajaForm.dominio);
      }
    } catch (e) {
      handleOpenAlert("Error al cargar el almacén/exhibidor para etiquetado desde almacenamiento local");
    }
  }, []);

  useEffect(() => {
    if (almacenExhibidorEtiquetado) {
      localStorage.setItem('etiquetado_almacenExhibidor', almacenExhibidorEtiquetado);
    }
  }, [almacenExhibidorEtiquetado]);

  const [statusEnableFieldsEtiquetado, setStatusEnableFieldsEtiquetado] =
    useState(false);
  //-------------------Etiquetado-----------------------------------
  const [openModalConfirmIntegrar, setOpenModalConfirmIntegrar] = useState(false);
  const [openModalConfirmSoloEtiquetado, setOpenModalConfirmSoloEtiquetado] = useState(false);

  // Estado del agente PrinterTools local (puerto 4000).
  const [estadoPrinterTools, setEstadoPrinterTools] = useState({
    verificando: false,
    enLinea: false,
    nombreEquipo: "",
  });

  const validarConexionPrinterTools = async (mostrarLoader = true) => {
    setEstadoPrinterTools((prev) => ({ ...prev, verificando: true }));
    if (mostrarLoader) handleOpenLoader("Validando estación de etiquetado...");
    try {
      const response = await fetch("http://localhost:4000/api/nombreequipo");
      if (!response.ok) throw new Error(response.statusText);
      const data = await response.json();
      if (!data?.name) throw new Error("Nombre de equipo no disponible");
      setEstadoPrinterTools({ verificando: false, enLinea: true, nombreEquipo: data.name });
      return true;
    } catch (error) {
      setEstadoPrinterTools({ verificando: false, enLinea: false, nombreEquipo: "" });
      return false;
    } finally {
      if (mostrarLoader) handleCloseLoader();
      setEstadoPrinterTools((prev) => ({ ...prev, verificando: false }));
    }
  };

  // Estado de la impresora de etiquetas (PrinterTools). Los menús de
  // etiquetado se deshabilitan cuando canPrint === false.
  const [estadoImpresoraEtiqueta, setEstadoImpresoraEtiqueta] = useState({
    verificando: false,
    canPrint: false,
    exists: false,
    statusCode: "UNKNOWN",
    message: "Impresora aún no verificada",
    printerName: "",
  });

  // Impresora alternativa opcional (solo sesión): si se captura, se usa en
  // lugar de la predeterminada sin perder lo ya etiquetado. Vacía = default.
  const [impresoraAlternativaEtiqueta, setImpresoraAlternativaEtiqueta] = useState("");

  // Catálogo de impresoras locales/red con estado (para Autocomplete).
  const [listaImpresorasEtiqueta, setListaImpresorasEtiqueta] = useState([]);

  const obtenerImpresoraEfectivaEtiqueta = (override) => {
    const alt = String(override ?? impresoraAlternativaEtiqueta ?? "").trim();
    if (alt) return alt;
    return resolverNombreImpresoraEtiqueta(parametrosCajaForm);
  };

  const cargarListaImpresorasEtiqueta = async () => {
    const lista = await listarImpresorasConEstado();
    setListaImpresorasEtiqueta(lista);
    return lista;
  };

  const validarImpresoraEtiqueta = async (mostrarLoader = true, printerNameOverride) => {
    const printerName = obtenerImpresoraEfectivaEtiqueta(printerNameOverride);
    // La alternativa es temporal: nunca debe sobrescribir la predeterminada.
    const esAlternativa = !!String(printerNameOverride ?? impresoraAlternativaEtiqueta ?? "").trim();
    setEstadoImpresoraEtiqueta((prev) => ({ ...prev, verificando: true, printerName }));
    if (mostrarLoader) handleOpenLoader("Validando impresora de etiquetas...");
    try {
      const estado = await validarEstadoImpresoraPrinterTools(printerName);
      if (estado.printerName && !esAlternativa) guardarNombreImpresoraEtiqueta(estado.printerName);
      setEstadoImpresoraEtiqueta({ ...estado, verificando: false });
      return estado.canPrint === true;
    } finally {
      if (mostrarLoader) handleCloseLoader();
      setEstadoImpresoraEtiqueta((prev) => ({ ...prev, verificando: false }));
    }
  };

  const handleOpenModalConfirmIntegrar = () => {
    setOpenModalConfirmIntegrar(true);
  };

  const handleCloseModalConfirmIntegrar = () => {
    setOpenModalConfirmIntegrar(false);
  };

  const handleOpenModalConfirmSoloEtiquetado = () => {
    setOpenModalConfirmSoloEtiquetado(true);
  };

  const handleCloseModalConfirmSoloEtiquetado = () => {
    setOpenModalConfirmSoloEtiquetado(false);
  };

  const handleConfirmIntegrarInventario = async (confirmar) => {
    setOpenModalConfirmIntegrar(false);

    if (!confirmar) return;

    const printerName = obtenerImpresoraEfectivaEtiqueta();
    if (!printerName) {
      handleOpenAlert("No se encontró la impresora de etiquetas configurada. Configure la impresora en Parámetros de Caja.");
      return;
    }
    // Solo persiste la predeterminada; la alternativa es temporal de sesión.
    if (!String(impresoraAlternativaEtiqueta || "").trim()) {
      guardarNombreImpresoraEtiqueta(printerName);
    }

    // Validación de estado antes de imprimir/integrar: no se toca inventario
    // ni se limpia el etiquetado si la impresora está fuera de línea.
    handleOpenLoader("Validando impresora de etiquetas...");
    let estado;
    try {
      estado = await validarEstadoImpresoraPrinterTools(printerName);
    } finally {
      handleCloseLoader();
    }
    setEstadoImpresoraEtiqueta({ ...estado, verificando: false });
    if (estado.canPrint !== true) {
      handleOpenAlert(estado.message || "Impresora de etiquetas no disponible.", "error");
      return;
    }

    await ejecutarImpresionYIntegracion({
      dataLineas: null,
      printerName,
      almacen: almacenExhibidorEtiquetado,
      integrar: true,
      parametros: parametrosCajaForm,
    });
  };

  const handleConfirmSoloEtiquetado = async (confirmar) => {
    setOpenModalConfirmSoloEtiquetado(false);

    if (!confirmar) return;

    const printerName = obtenerImpresoraEfectivaEtiqueta();
    if (!printerName) {
      handleOpenAlert("No se encontró la impresora de etiquetas configurada. Configure la impresora en Parámetros de Caja.");
      return;
    }
    // Solo persiste la predeterminada; la alternativa es temporal de sesión.
    if (!String(impresoraAlternativaEtiqueta || "").trim()) {
      guardarNombreImpresoraEtiqueta(printerName);
    }

    // Validación de estado antes de imprimir: no se limpia el etiquetado
    // si la impresora está fuera de línea.
    handleOpenLoader("Validando impresora de etiquetas...");
    let estado;
    try {
      estado = await validarEstadoImpresoraPrinterTools(printerName);
    } finally {
      handleCloseLoader();
    }
    setEstadoImpresoraEtiqueta({ ...estado, verificando: false });
    if (estado.canPrint !== true) {
      handleOpenAlert(estado.message || "Impresora de etiquetas no disponible.", "error");
      return;
    }

    await ejecutarImpresionYIntegracion({
      dataLineas: null,
      printerName,
      almacen: almacenExhibidorEtiquetado,
      integrar: false,
      parametros: parametrosCajaForm,
    });
  };

  const handleObtenerFolioEntradaDisponible = async (pcOverride) => {
    const pcActual = pcOverride || parametrosCajaForm.caja.trim().toUpperCase();
    const response = await GetRequest({
      url: apiFolioDisponibleEntradas.replace(
        "{pc}",
        pcActual
      ),
      loader: "Consultando folio de entrada disponible...",
    });

    if (response.HasError) {
      setFolioEntrada(0);
    }

    if (response.result == null) {
      setFolioEntrada(0);
    }

    setFolioEntrada(response?.result);
    return response?.result;
  };

  const handleObtenerFolioSalidaDisponible = async (pcOverride) => {
    const pcActual = pcOverride || parametrosCajaForm.caja.trim().toUpperCase();
    const response = await GetRequest({
      url: apiFolioDisponibleSalidas.replace(
        "{pc}",
        pcActual
      ),
      loader: "Consultando folio de salida disponible...",
    });

    if (response.HasError) {
      setFolioSalida(0);
    }

    if (response.result == null) {
      setFolioSalida(0);
    }
    setFolioSalida(response?.result);
    return response?.result;
  };

  // Split loader for entries and exits (Entradas / Salidas)
  // ─── Comparador clave/medida/almacén (misma llave que el agrupado del backend) ──
  const claveMedidaAlmacenIguales = (a, b) => {
    const normT = (v) => String(v ?? "").trim().toUpperCase();
    const normM = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? String(n) : normT(v);
    };
    return (
      normT(a?.clavearticulo ?? a?.sClaveArticulo) === normT(b?.clavearticulo ?? b?.sClaveArticulo) &&
      normM(a?.medida ?? a?.dMedida) === normM(b?.medida ?? b?.dMedida) &&
      normT(a?.almacenexhibidor ?? a?.sAlmacenExhibidor) === normT(b?.almacenexhibidor ?? b?.sAlmacenExhibidor)
    );
  };

  // ─── Id local único (negativo) para filas aún no guardadas ───────────────────
  // Siempre por debajo del mínimo existente: único en la lista y entre recargas.
  // Sin esto, varias filas con id undefined/null se "seleccionan" todas a la vez
  // porque la tabla colorea por comparacion de id.
  const nuevoIdLocal = (lista) => {
    let min = 0;
    for (const r of Array.isArray(lista) ? lista : []) {
      const n = Number(r?.id);
      if (Number.isFinite(n) && n < min) min = n;
    }
    return min - 1;
  };

  // ─── Mezcla pendientes locales (mismo folio+PC) sobre la lista del servidor ────
  // Lo local manda en duplicados. Persiste el resultado como working set para que
  // el guardado batch (que REEMPLAZA el folio en backend) siempre lleve la foto completa.
  const mezclarPendientesLocales = (listaServidor, folio, pcActual, tipo) => {
    const base = Array.isArray(listaServidor) ? listaServidor : [];
    const esEntrada = String(tipo || "").trim().toUpperCase() === "ENTRADA";
    const servicio = esEntrada ? EntradasLocalService : SalidasLocalService;
    let pendientes = [];
    try { pendientes = servicio.cargar() || []; } catch { pendientes = []; }
    const pcNorm = String(pcActual || parametrosCajaForm.caja || "").trim().toUpperCase();
    const host = String(parametrosCajaForm.caja || "").trim().toUpperCase();
    const mismos = (Array.isArray(pendientes) ? pendientes : []).filter((p) => {
      const f = p.folioentradasalida ?? p.iFolioEntradaSalida;
      if (String(f ?? "") !== String(folio ?? "")) return false;
      const ppc = String(p.pc || host || "").trim().toUpperCase();
      return ppc === pcNorm;
    });
    if (mismos.length === 0) return { lista: base, conPendientes: false };
    const merged = [...base];
    for (const p of mismos) {
      const idx = merged.findIndex((r) => claveMedidaAlmacenIguales(r, p));
      if (idx >= 0) merged[idx] = { ...merged[idx], ...p };
      else merged.push(p);
    }
    // Backfill de id (inmutable): ninguna fila puede quedar sin id único,
    // porque la tabla colorea por comparacion de id y se "seleccionan" varias.
    let minId = 0;
    for (const r of merged) {
      const n = Number(r?.id);
      if (Number.isFinite(n) && n < minId) minId = n;
    }
    const vistos = new Set();
    const saneada = merged.map((r) => {
      const n = Number(r?.id);
      if (r?.id !== undefined && r?.id !== null && Number.isFinite(n) && !vistos.has(n)) {
        vistos.add(n);
        return r;
      }
      minId -= 1;
      vistos.add(minId);
      return { ...r, id: minId };
    });
    try { servicio.guardar(saneada); } catch {}
    return { lista: saneada, conPendientes: true };
  };

  // ─── Purga pendientes de un folio+PC ya terminado/cancelado (no se pueden guardar) ──
  const purgarPendientesFolio = (folio, pcActual, tipo) => {
    try {
      const esEntrada = String(tipo || "").trim().toUpperCase() === "ENTRADA";
      const servicio = esEntrada ? EntradasLocalService : SalidasLocalService;
      const todos = servicio.cargar() || [];
      const pcNorm = String(pcActual || parametrosCajaForm.caja || "").trim().toUpperCase();
      const host = String(parametrosCajaForm.caja || "").trim().toUpperCase();
      const resto = todos.filter((p) => {
        const f = p.folioentradasalida ?? p.iFolioEntradaSalida;
        const ppc = String(p.pc || host || "").trim().toUpperCase();
        return !(String(f ?? "") === String(folio ?? "") && ppc === pcNorm);
      });
      if (resto.length !== todos.length) servicio.guardar(resto);
    } catch {}
  };

  const handleCargarEntradas = async (folio = folioEntrada, concepto, almacen, pcOverride, options = {}) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;
    const mantenerModoEdicion = options?.mantenerModoEdicion === true;

    const pcActual = pcOverride || parametrosCajaForm.caja?.trim().toUpperCase();
    let url = apiObtenerEntradasSalidas
      .replace("{folioentradasalida}", folio)
      .replace("{tipo}", "ENTRADA")
      .replace("{pc}", pcActual);

    const response = await GetRequest({
      url,
      loader: "Consultando folio de entrada...",
    });


    if (response.HasError || response.result == null) {
      // Antes de rendirse: si hay pendientes locales de este folio+PC, mostrarlos
      const { lista: rec, conPendientes } = mezclarPendientesLocales([], folio, pcActual, "ENTRADA");
      if (conPendientes) {
        setDataEntradas(getDataEntradasSalidas());
        setListaEntradas(rec);
        setStatusEntrada("PENDIENTE");
        setTitleActionSave("GUARDAR");
        if (rec[0]?.conceptoentradasalida) setConceptoEntrada(String(rec[0].conceptoentradasalida).trim());
        if (rec[0]?.almacenexhibidor) setAlmacenExhibidor(String(rec[0].almacenexhibidor).trim());
        return;
      }
      setDataEntradas(getDataEntradasSalidas());
      setListaEntradas([]);
      setStatusEntrada("PENDIENTE");
      if (mantenerModoEdicion) {
        setTitleActionSave("GUARDAR");
      } else {
        setTitleActionSave("NUEVA");
      }
      // No limpiar conceptos - mantener el último usado (del storage) para nuevas capturas

      return;
    }

    // La respuesta ES la lista de partidas (array)
    const result = response?.result;
    
    if (!result) {
      const { lista: rec, conPendientes } = mezclarPendientesLocales([], folio, pcActual, "ENTRADA");
      if (conPendientes) {
        setDataEntradas(getDataEntradasSalidas());
        setListaEntradas(rec);
        setStatusEntrada("PENDIENTE");
        setTitleActionSave("GUARDAR");
        if (rec[0]?.conceptoentradasalida) setConceptoEntrada(String(rec[0].conceptoentradasalida).trim());
        if (rec[0]?.almacenexhibidor) setAlmacenExhibidor(String(rec[0].almacenexhibidor).trim());
        return;
      }
      setDataEntradas(getDataEntradasSalidas());
      setListaEntradas([]);
      setStatusEntrada("PENDIENTE");
      if (mantenerModoEdicion) {
        setTitleActionSave("GUARDAR");
      } else {
        setTitleActionSave("NUEVA");
      }
      // No limpiar conceptos - mantener el último usado (del storage) para nuevas capturas
      return;
    }

    const listaData = Array.isArray(result) ? result : [result];
    
    // Tomar el primer elemento para los datos de cabecera
    const primerElemento = listaData[0];
    
    setDataEntradas(primerElemento);

    // Actualizar el status de la entrada
    if (primerElemento?.statusentradasalida) {
      setStatusEntrada(primerElemento.statusentradasalida);
    }

    // Seter el concepto y almacen solo si se proporcionan explícitamente (no null/undefined/vacío)
    // Si no hay concepto en parámetros, usar el de la base de datos (primerElemento)
    if (concepto && concepto.trim()) {
      setConceptoEntrada(concepto.trim());
    } else if (primerElemento?.conceptoentradasalida) {
      setConceptoEntrada(primerElemento.conceptoentradasalida.trim());
    }

    if (almacen) {
      setAlmacenExhibidor(almacen);
    } else if (!almacen && almacen !== "" && primerElemento?.almacenexhibidor) {
      setAlmacenExhibidor(primerElemento.almacenexhibidor);
    }

    // La respuesta ES la lista de partidas
    const statusNormalizado = (primerElemento?.statusentradasalida || "").trim().toUpperCase();
    const estaTerminado = statusNormalizado === "TR" || statusNormalizado === "CA";
    if (estaTerminado) {
      // Terminado/cancelado: no se mezcla ni se edita; se purgan pendientes obsoletos
      purgarPendientesFolio(folio, pcActual, "ENTRADA");
      setListaEntradas(listaData);
      if (!mantenerModoEdicion) setTitleActionSave("EDITAR");
      else setTitleActionSave("GUARDAR");
      return;
    }

    // Mezclar pendientes locales (mismo folio+PC) para no perder captura sin guardar
    const { lista: listaMezclada } = mezclarPendientesLocales(listaData, folio, pcActual, "ENTRADA");
    setListaEntradas(listaMezclada);

    if (mantenerModoEdicion) {
      setTitleActionSave("GUARDAR");
    } else if (listaMezclada.length > 0) {
      setTitleActionSave("GUARDAR");
    } else {
      setTitleActionSave("NUEVA");
    }

    // Solo restaurar de localStorage si el backend NO tiene datos
    // (ej. usuario salió sin guardar y regresa al mismo folio)
    if (!listaMezclada || listaMezclada.length === 0) {
      const { lista: rec, conPendientes } = mezclarPendientesLocales([], folio, pcActual, "ENTRADA");
      if (conPendientes) {
        setListaEntradas(rec);
        setTitleActionSave("GUARDAR");
        if (rec[0]?.conceptoentradasalida) {
          setConceptoEntrada(String(rec[0].conceptoentradasalida).trim());
        }
        if (rec[0]?.almacenexhibidor) {
          setAlmacenExhibidor(String(rec[0].almacenexhibidor).trim());
        }
      }
    }
  };

  const handleCargarSalidas = async (folio = folioSalida, concepto, almacen, pcOverride, options = {}) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;
    const mantenerModoEdicion = options?.mantenerModoEdicion === true;

    const pcActual = pcOverride || parametrosCajaForm.caja?.trim().toUpperCase();
    let url = apiObtenerEntradasSalidas
      .replace("{folioentradasalida}", folio)
      .replace("{tipo}", "SALIDA")
      .replace("{pc}", pcActual);

    const response = await GetRequest({
      url,
      loader: "Consultando folio de salida...",
    });

    if (response.HasError || response.result == null) {
      const { lista: rec, conPendientes } = mezclarPendientesLocales([], folio, pcActual, "SALIDA");
      if (conPendientes) {
        setDataSalidas(getDataEntradasSalidas());
        setListaSalidas(rec);
        setStatusSalida("PENDIENTE");
        setTitleActionSave("GUARDAR");
        if (rec[0]?.conceptoentradasalida) setConceptoSalida(String(rec[0].conceptoentradasalida).trim());
        if (rec[0]?.almacenexhibidor) setAlmacenExhibidorSalida(String(rec[0].almacenexhibidor).trim());
        return;
      }
      setDataSalidas(getDataEntradasSalidas());
      setListaSalidas([]);
      setStatusSalida("PENDIENTE");
      if (mantenerModoEdicion) {
        setTitleActionSave("GUARDAR");
      } else if (titleActionSave !== "GUARDAR") {
        setTitleActionSave("NUEVA");
      }
      // No limpiar conceptos - mantener el último usado (del storage) para nuevas capturas

      return;
    }

    // La respuesta ES la lista de partidas (array) - igual que entradas
    const result = response?.result;
    
    if (!result) {
      const { lista: rec, conPendientes } = mezclarPendientesLocales([], folio, pcActual, "SALIDA");
      if (conPendientes) {
        setDataSalidas(getDataEntradasSalidas());
        setListaSalidas(rec);
        setStatusSalida("PENDIENTE");
        setTitleActionSave("GUARDAR");
        if (rec[0]?.conceptoentradasalida) setConceptoSalida(String(rec[0].conceptoentradasalida).trim());
        if (rec[0]?.almacenexhibidor) setAlmacenExhibidorSalida(String(rec[0].almacenexhibidor).trim());
        return;
      }
      setDataSalidas(getDataEntradasSalidas());
      setListaSalidas([]);
      setStatusSalida("PENDIENTE");
      if (mantenerModoEdicion) {
        setTitleActionSave("GUARDAR");
      } else if (titleActionSave !== "GUARDAR") {
        setTitleActionSave("NUEVA");
      }
      // No limpiar conceptos - mantener el último usado (del storage) para nuevas capturas
      return;
    }

    const listaData = Array.isArray(result) ? result : [result];
    
    // Tomar el primer elemento para los datos de cabecera
    const primerElemento = listaData[0];
    setDataSalidas(primerElemento);

    // Actualizar el status de la salida
    if (primerElemento?.statusentradasalida) {
      setStatusSalida(primerElemento.statusentradasalida);
    }

    // Seter el concepto y almacen solo si se proporcionan explícitamente (no null/undefined/vacío)
    // Si no hay concepto en parámetros, usar el de la base de datos (primerElemento)
    if (concepto && concepto.trim()) {
      setConceptoSalida(concepto.trim());
    } else if (primerElemento?.conceptoentradasalida) {
      setConceptoSalida(primerElemento.conceptoentradasalida.trim());
    }
    if (almacen) {
      setAlmacenExhibidorSalida(almacen);
    } else if (!almacen && almacen !== "" && primerElemento?.almacenexhibidor) {
      setAlmacenExhibidorSalida(primerElemento.almacenexhibidor);
    }

    // La respuesta ES la lista de partidas
    const statusNormalizado = (primerElemento?.statusentradasalida || "").trim().toUpperCase();
    const estaTerminado = statusNormalizado === "TR" || statusNormalizado === "CA";
    if (estaTerminado) {
      // Terminado/cancelado: no se mezcla ni se edita; se purgan pendientes obsoletos
      purgarPendientesFolio(folio, pcActual, "SALIDA");
      setListaSalidas(listaData);
      if (mantenerModoEdicion) setTitleActionSave("GUARDAR");
      else setTitleActionSave("EDITAR");
      return;
    }

    // Mezclar pendientes locales (mismo folio+PC) para no perder captura sin guardar
    const { lista: listaMezcladaSal } = mezclarPendientesLocales(listaData, folio, pcActual, "SALIDA");
    setListaSalidas(listaMezcladaSal);

    if (mantenerModoEdicion) {
      setTitleActionSave("GUARDAR");
    } else if (listaMezcladaSal.length > 0) {
      setTitleActionSave("GUARDAR");
    } else {
      setTitleActionSave("NUEVA");
    }

    // Solo restaurar de localStorage si el backend NO tiene datos
    if (!listaMezcladaSal || listaMezcladaSal.length === 0) {
      const { lista: rec, conPendientes } = mezclarPendientesLocales([], folio, pcActual, "SALIDA");
      if (conPendientes) {
        setListaSalidas(rec);
        setTitleActionSave("GUARDAR");
        if (rec[0]?.conceptoentradasalida) {
          setConceptoSalida(String(rec[0].conceptoentradasalida).trim());
        }
        if (rec[0]?.almacenexhibidor) {
          setAlmacenExhibidorSalida(String(rec[0].almacenexhibidor).trim());
        }
      }
    }
  };

  const handleCargarSalidasOtraPC = async (folio, pc, concepto, almacen) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;
    if (!folio) return;

    let url = apiObtenerEntradasSalidas
      .replace("{folioentradasalida}", folio)
      .replace("{tipo}", "SALIDA")
      .replace("{pc}", pc?.trim().toUpperCase());

    const response = await GetRequest({
      url,
      loader: "Consultando folio de salida de otra PC...",
    });

    if (response.HasError || response.result == null) {
      setDataSalidas(getDataEntradasSalidas());
      setListaSalidas([]);
      setTitleActionSave("NUEVA");
      // No limpiar conceptos - mantener el último usado para nuevas capturas

      return;
    }

    const result = response?.result;
    if (!result) {
      setDataSalidas(getDataEntradasSalidas());
      setListaSalidas([]);
      setTitleActionSave("NUEVA");
      // No limpiar conceptos - mantener el último usado para nuevas capturas
      return;
    }

    const listaData = Array.isArray(result) ? result : [result];
    const primerElemento = listaData[0];
    setDataSalidas(primerElemento);
    setFolioSalida(folio);

    // Seter el concepto y almacen - igual que handleCargarSalidas
    // Si no hay concepto en parámetros, usar el de la base de datos (primerElemento)
    if (concepto && concepto.trim()) {
      setConceptoSalida(concepto.trim());
    } else if (primerElemento?.conceptoentradasalida) {
      setConceptoSalida(primerElemento.conceptoentradasalida.trim());
    }
    if (almacen) {
      setAlmacenExhibidorSalida(almacen);
    } else if (!almacen && almacen !== "" && primerElemento?.almacenexhibidor) {
      setAlmacenExhibidorSalida(primerElemento.almacenexhibidor);
    }

    // Usar el array completo para las partidas
    const statusNormalizado = (primerElemento?.statusentradasalida || "").trim().toUpperCase();
    const estaTerminado = statusNormalizado === "TR" || statusNormalizado === "CA";
    if (estaTerminado) {
      purgarPendientesFolio(folio, pc, "SALIDA");
      setListaSalidas(listaData);
    } else {
      const { lista: mezclada } = mezclarPendientesLocales(listaData, folio, pc, "SALIDA");
      setListaSalidas(mezclada);
    }
    setTitleActionSave(listaData.length > 0 ? (estaTerminado ? "EDITAR" : "GUARDAR") : "NUEVA");

  };

  const handleCargarDatosEntradaOtraPC = async (folio, pc, concepto, almacen) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;
    if (!folio) return;

    let url = apiObtenerEntradasSalidas
      .replace("{folioentradasalida}", folio)
      .replace("{tipo}", "ENTRADA")
      .replace("{pc}", pc?.trim().toUpperCase());

    const response = await GetRequest({
      url,
      loader: "Consultando folio de entrada de otra PC...",
    });

    if (response.HasError || response.result == null) {
      setDataEntradas(getDataEntradasSalidas());
      setListaEntradas([]);
      setTitleActionSave("NUEVA");
      // No limpiar conceptos - mantener el último usado para nuevas capturas
      return;
    }

    const resultArray = Array.isArray(response?.result) ? response?.result : [response?.result];
    const primerElemento = resultArray[0];
    setDataEntradas(primerElemento);
    setFolioEntrada(folio);

    // Actualizar el status de la entrada
    if (primerElemento?.statusentradasalida) {
      setStatusEntrada(primerElemento.statusentradasalida);
    }

    // Seter el concepto y almacen - si no hay en parámetros, usar el de la base de datos
    if (concepto && concepto.trim()) {
      setConceptoEntrada(concepto.trim());
    } else if (primerElemento?.conceptoentradasalida) {
      setConceptoEntrada(primerElemento.conceptoentradasalida.trim());
    }
    if (almacen && almacen.trim()) {
      setAlmacenExhibidor(almacen.trim());
    } else if (primerElemento?.almacenexhibidor) {
      setAlmacenExhibidor(primerElemento.almacenexhibidor.trim());
    }

    // Usar el array completo para las partidas
    const statusNormalizado = (primerElemento?.statusentradasalida || "").trim().toUpperCase();
    const estaTerminado = statusNormalizado === "TR" || statusNormalizado === "CA";
    if (estaTerminado) {
      purgarPendientesFolio(folio, pc, "ENTRADA");
      setListaEntradas(resultArray);
    } else {
      const { lista: mezclada } = mezclarPendientesLocales(resultArray, folio, pc, "ENTRADA");
      setListaEntradas(mezclada);
    }

    setTitleActionSave(resultArray.length > 0 ? (estaTerminado ? "EDITAR" : "GUARDAR") : "NUEVA");

    // Limpiar lista de salidas para evitar mezcla
    setListaSalidas([]);
  };

  const handleObtenerDatosEntradas = async (folio, concepto, almacen, pcOverride, options = {}) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;

    let folioActual = folio;
    if (folioActual === undefined || folioActual === null || folioActual === 0) {
      folioActual = folioEntrada;
    }

    if (folioActual && folioActual > 0) {
      setFolioEntrada(folioActual);
      await handleCargarEntradas(folioActual, concepto, almacen, pcOverride, options);
    } else if (folioActual === 0) {
      await handleObtenerFolioEntradaDisponible();
    }
  };

  const handleObtenerDatosSalidas = async (folio, concepto, almacen, pcOverride, options = {}) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;

    let folioActual = folio;
    if (folioActual === undefined || folioActual === null || folioActual === 0) {
      folioActual = folioSalida;
    }

    if (folioActual && folioActual > 0) {
      setFolioSalida(folioActual);
      await handleCargarSalidas(folioActual, concepto, almacen, pcOverride, options);
    } else if (folioActual === 0) {
      await handleObtenerFolioSalidaDisponible();
    }
  };

  // const handleBuscarEntreadasSalidas = async (tipo, status) => {
  //   if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
  //     return;
  //   }

  //   if (tipo === "" || status === "") {
  //     return;
  //   }

  //   let url = apiObtenerListaAgrupadaEntradasSalidas.replace(
  //     "{status}",
  //     status
  //   );
  //   url = url.replace("{tipo}", tipo);
  //   const response = await GetRequest({
  //     url,
  //     loader: "Consultando folio de entrada/salida...",
  //   });

  //   if (response.HasError) {
  //     return [];
  //   }

  //   if (response.result == null) {
  //     return [];
  //   }

  // };

  const handleObtenerArticuloDataFull = async (clave, medida) => {
    let url = apiBuscarArticuloPorClaveMedida.replace("{clavearticulo}", clave);
    url = url.replace("{medida}", medida);
    const response = await GetRequest({
      url,
      loader: "Obteniendo datos de arículo",
    });

    if (response.HasError) {
      return;
    }

    if (response?.result <= 0) {
      return;
    }
    return response?.result;
  };

  const handleRegistrarArticuloEntrada = async (data, pcOverride) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return null;

    if (!data || data.clavearticulo === null || data.clavearticulo === undefined) {
      handleOpenAlert(`Artículo no existente`);
      return null;
    }

    if (isNullOrEmpty(folioEntrada)) {
      handleOpenAlert(`Es necesario cargar una entrada`);
      return null;
    }

    if (isNullOrEmpty(String(conceptoEntrada || "").trim())) {
      handleOpenAlert(`Es necesario cargar el concepto para continuar`);
      return null;
    }

    if (isNullOrEmpty(String(almacenExhibidor || "").trim())) {
      handleOpenAlert(
        `Es necesario cargar el almacén/exhibidor para continuar`
      );
      return null;
    }

    const almacenNormalizado = almacenExhibidor?.trim().toUpperCase() || "";
    const almacenValido = listaAlmacenesExhibidoresEntrada.some(
      (item) => item.almacenexhibidor.trim().toUpperCase() === almacenNormalizado
    );
    if (!almacenValido) {
      handleOpenAlert(`El almacén/exhibidor "${almacenExhibidor}" no es válido. Seleccione uno de la lista.`);
      return null;
    }

    const statusEntradaActual = (statusEntrada || "").trim().toUpperCase();
    if (statusEntradaActual === "TR" || statusEntradaActual === "CA") {
      handleOpenAlert(
        statusEntradaActual === "CA"
          ? `Entrada cancelada, no se pueden registrar más articulos`
          : `Entrada ya terminada, no se pueden registrar más articulos`
      );
      return null;
    }

    const cantidad = data.cantidad && data.cantidad > 0 ? data.cantidad : 1;
    const factor = data.factor ? data.factor : 1;
    const pcActual = (pcOverride || parametrosCajaForm.caja).toUpperCase();

    const partida = {
      clavearticulo: data.clavearticulo,
      descripcion: data.descripcion || '',
      medida: data.medida,
      cantidadarticulo: cantidad,
      factor: factor,
      folioentradasalida: folioEntrada,
      conceptoentradasalida: conceptoEntrada,
      pmvb: data.pmvb || 0,
      costoventa: data.preciodefinitivo || 0,
      almacenexhibidor: almacenExhibidor,
      usuario: usuario,
      pc: pcActual,
      statusentradasalida: "PE",
    };

    // Captura sobre la lista COMPLETA en pantalla (servidor + pendientes ya
    // mezclados): así un escaneo posterior no puede borrar lo previamente
    // guardado. El working set resultante se persiste para el batch (que reemplaza).
    setListaEntradas(prev => {
      const base = Array.isArray(prev) ? prev : [];
      const index = base.findIndex((item) => claveMedidaAlmacenIguales(item, partida));
      let updated;
      if (index >= 0) {
        updated = [...base];
        const suma = (Number(updated[index].cantidadarticulo) || 0) + cantidad;
        updated[index] = { ...updated[index], cantidadarticulo: suma };
      } else {
        // Id asignado dentro del updater: único aunque haya escaneos seguidos
        updated = [...base, { ...partida, id: nuevoIdLocal(base) }];
      }
      try { EntradasLocalService.guardar(updated); } catch {}
      return updated;
    });

    setTitleActionSave("GUARDAR");
    return partida;
  };

  const handleRegistrarArticuloSalida = async (data, pcOverride) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return null;

    if (!data) return null;

    const codigobarras = data.codigobarras || data.codigoBarras || data.clavearticulo;
    if (!codigobarras) {
      handleOpenAlert(`Código de barras no proporcionado`);
      return null;
    }

    if (isNullOrEmpty(folioSalida)) {
      handleOpenAlert(`Es necesario cargar una salida`);
      return null;
    }

    if (isNullOrEmpty(conceptoSalida)) {
      handleOpenAlert(`Es necesario cargar el concepto para continuar`);
      return null;
    }

    const almacenNormalizado = almacenExhibidorSalida?.trim().toUpperCase() || "";
    const almacenValido = listaAlmacenesExhibidoresSalida.some(
      (item) => item.almacenexhibidor.trim().toUpperCase() === almacenNormalizado
    );
    if (!almacenValido) {
      handleOpenAlert(`El almacén/exhibidor "${almacenExhibidorSalida}" no es válido. Seleccione uno de la lista.`);
      return null;
    }

    const statusSalidaActual = (statusSalida || "").trim().toUpperCase();
    if (statusSalidaActual === "TR" || statusSalidaActual === "CA") {
      handleOpenAlert(
        statusSalidaActual === "CA"
          ? `Salida cancelada, no se pueden registrar más articulos`
          : `Salida ya terminada, no se pueden registrar más articulos`
      );
      return null;
    }

    const pcActual = (pcOverride || parametrosCajaForm.caja).toUpperCase();

    const capturaResponse = await PostRequest({
      url: apiSalidasCapturar,
      loader: "Capturando artículo en salida...",
      body: {
        clavearticulo: data.clavearticulo || '',
        descripcion: data.descripcion || '',
        medida: data.medida || 0,
        factor: data.factor || 0,
        pmvb: data.pmvb || 0,
        costoventa: data.costoventa || data.preciodefinitivo || 0,
        cantidadacumulada: data.cantidadacumulada || data.cantidadAcumulada || 0,
        captureindex: data.captureindex || data.captureIndex || 0,
        codigobarras: codigobarras?.trim(),
        folio: folioSalida,
        concepto: conceptoSalida,
        almacenexhibidor: almacenExhibidorSalida,
        pc: pcActual,
        usuario: usuario,
      },
    });

    if (capturaResponse?.HasError || capturaResponse?.hasError) {
      const msg = (capturaResponse?.message || "").toLowerCase();
      if (msg.includes("sin existencia") || msg.includes("sin stock") || msg.includes("insuficiente")) {
        const sinStockItem = {
          clavearticulo: data.clavearticulo || codigobarras?.trim() || '',
          descripcion: data.descripcion || '',
          medida: data.medida || '',
          existencia: 0,
        };
        SalidasLocalService.agregarSinExistencias(sinStockItem);
        return { registrado: false, ...sinStockItem };
      }
      handleOpenAlert(capturaResponse?.message || "Error al capturar artículo en salida");
      return null;
    }

    const captura = capturaResponse?.result;
    if (!captura) return null;

    if (!captura.registrado) {
      const sinStockItem = {
        clavearticulo: captura.clavearticulo || '',
        descripcion: captura.descripcion || '',
        medida: captura.medida || '',
        existencia: captura.existencia || 0,
        solicitado: captura.solicitado || 0,
        acumulado: captura.acumulado || 0,
      };
      SalidasLocalService.agregarSinExistencias(sinStockItem);
      return captura;
    }

    const partidaRaw = captura.partida;
    if (partidaRaw) {
      const partida = {
        ...partidaRaw,
        codigobarras: partidaRaw.codigobarras || codigobarras?.trim() || '',
        descripcion: partidaRaw.descripcion || captura.descripcion || '',
        cantidadarticulo: partidaRaw.cantidad,
      };
      // Igual que entradas: la partida es el delta capturado y se SUMA sobre la
      // lista COMPLETA en pantalla, para que un escaneo no borre lo previamente
      // guardado. Se persiste el set (el batch reemplaza). Id único garantizado.
      setListaSalidas(prev => {
        const base = Array.isArray(prev) ? prev : [];
        const index = base.findIndex((item) => claveMedidaAlmacenIguales(item, partida));
        let updated;
        if (index >= 0) {
          updated = [...base];
          const suma = (Number(updated[index].cantidadarticulo) || 0) + (Number(partida.cantidadarticulo) || 0);
          updated[index] = { ...updated[index], cantidadarticulo: suma };
        } else {
          const item = (partida.id === undefined || partida.id === null)
            ? { ...partida, id: nuevoIdLocal(base) }
            : partida;
          updated = [...base, item];
        }
        try { SalidasLocalService.guardar(updated); } catch {}
        return updated;
      });
    }

    setTitleActionSave("GUARDAR");
    return captura;
  };

  const handleCargarEscaneosFromFile = () => { };

  const handleClickNuevaEntrada = async () => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    // Rev 6: finar lo pendiente y liberar el buffer del folio anterior para
    // la nueva captura (la captura anterior ya quedó almacenada en SQL).
    const folioAnterior = folioEntrada;
    const pcAnterior = String(parametrosCajaForm.caja || "").trim().toUpperCase();
    if (titleActionSave === "GUARDAR") {
      if (!(await handleFlushEntradaRedis())) return;
    }

    setStatusEntrada("PENDIENTE");
    setListaEntradas([]);
    setOpenModalBuscarArticulos(false);
    setTitleActionSave("GUARDAR");

    let folioDisponible1 = await handleObtenerFolioEntradaDisponible();
    const statusEntrada = await handleObtenerStatusEntradaSalida(
      folioDisponible1,
      parametrosCajaForm.caja.trim().toUpperCase(),
      "ENTRADA"
    );
    const entradaActualTienePartidas = listaEntradas.some(
      (item) => String(item.folioentradasalida || item.iFolioEntradaSalida || "") === String(folioDisponible1)
    );

    if (
      statusEntrada === "TR" ||
      (entradaActualTienePartidas && statusEntrada === "PE")
    )
      await handleIncrementarFolioEntrada();
    let folioDisponible2 = await handleObtenerFolioEntradaDisponible();
    // Limpieza del folio nuevo obtenido (SQL + Redis por folio+PC, aislado
    // por tenant). El flujo sigue igual y la entrada cargará vacía en PENDIENTE.
    try {
      await PostRequest({
        url: apiLimpiezaNuevo,
        body: {
          tipo: "ENTRADA",
          folio: folioDisponible2,
          pc: String(parametrosCajaForm.caja || "").trim().toUpperCase(),
        },
      });
    } catch {}
    await handleObtenerDatosEntradas(folioDisponible2, null, null, null, { mantenerModoEdicion: true });
    if (folioAnterior && folioAnterior !== folioDisponible2) {
      await eliminarBufferRedis("ENTRADA", folioAnterior, pcAnterior);
    }
    setTitleActionSave("GUARDAR");
  };

  const handleClickNuevaSalida = async () => {
    SalidasLocalService.limpiar();
    SalidasLocalService.limpiarSinExistencias();

    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    // Rev 6: finar lo pendiente y liberar el buffer del folio anterior para
    // la nueva captura (la captura anterior ya quedó almacenada en SQL).
    const folioAnteriorSal = folioSalida;
    const pcAnteriorSal = String(parametrosCajaForm.caja || "").trim().toUpperCase();
    if (titleActionSave === "GUARDAR") {
      if (!(await handleFlushSalidaRedis())) return;
    }

    setStatusSalida("PENDIENTE");
    setListaSalidas([]);
    setOpenModalBuscarArticulos(false);
    setTitleActionSave("GUARDAR");

    let folioDisponible1 = await handleObtenerFolioSalidaDisponible();
    const statusSalida = await handleObtenerStatusEntradaSalida(
      folioDisponible1,
      parametrosCajaForm.caja.trim().toUpperCase(),
      "SALIDA"
    );
    const salidaActualTienePartidas = listaSalidas.some(
      (item) => String(item.folioentradasalida || item.iFolioEntradaSalida || "") === String(folioDisponible1)
    );
    const statusSalidaNormalizado = (statusSalida || "").trim().toUpperCase();

    if (
      statusSalidaNormalizado === "TR" ||
      statusSalidaNormalizado === "CA" ||
      (salidaActualTienePartidas && statusSalidaNormalizado === "PE")
    )
      await handleIncrementarFolioSalidas();
    let folioDisponible2 = await handleObtenerFolioSalidaDisponible();
    // Limpieza del folio nuevo obtenido (SQL + Redis por folio+PC, aislado
    // por tenant). El flujo sigue igual y la salida cargará vacía en PENDIENTE.
    try {
      await PostRequest({
        url: apiLimpiezaNuevo,
        body: {
          tipo: "SALIDA",
          folio: folioDisponible2,
          pc: String(parametrosCajaForm.caja || "").trim().toUpperCase(),
        },
      });
    } catch {}
    await handleObtenerDatosSalidas(folioDisponible2, null, null, null, { mantenerModoEdicion: true });
    if (folioAnteriorSal && folioAnteriorSal !== folioDisponible2) {
      await eliminarBufferRedis("SALIDA", folioAnteriorSal, pcAnteriorSal);
    }
    setTitleActionSave("GUARDAR");
  };

  const handleGuardarEntrada = async (pcOverride, itemsOverride) => {
    const statusActual = (statusEntrada || "").trim().toUpperCase();
    if (statusActual === "TR" || statusActual === "CA") {
      handleOpenAlert(
        statusActual === "CA"
          ? "La entrada está cancelada, no se pueden guardar cambios"
          : "La entrada está terminada, no se pueden guardar cambios"
      );
      return false;
    }

    const itemsLocalStorage = EntradasLocalService.cargar();
    const items = Array.isArray(itemsOverride) && itemsOverride.length > 0
      ? itemsOverride
      : itemsLocalStorage.length > 0
        ? itemsLocalStorage
        : listaEntradas;
    if (!items || items.length === 0) {
      handleOpenAlert("No hay artículos para guardar");
      return false;
    }

    if (isNullOrEmpty(almacenExhibidor)) {
      handleOpenAlert("Seleccione un almacén/exhibidor");
      return false;
    }

    const pcGuardar = (pcOverride || parametrosCajaForm.caja || "").trim().toUpperCase();

    const body = {
      folio: folioEntrada,
      concepto: conceptoEntrada,
      almacenexhibidor: almacenExhibidor,
      pc: pcGuardar,
      usuario: usuario,
      items: items.map(i => ({
        clavearticulo: i.clavearticulo || i.sClaveArticulo,
        descripcion: i.descripcion || i.sDescripcion || '',
        medida: i.medida ?? i.dMedida,
        cantidad: i.cantidadarticulo ?? i.dCantidadArticulo ?? i.cantidad ?? i.dCantidad ?? 0,
        pmvb: i.pmvb ?? i.dPMVB ?? 0,
        costoventa: i.costoventa ?? i.dCostoVenta ?? 0,
        almacenexhibidor: i.almacenexhibidor || i.sAlmacenExhibidor || almacenExhibidor,
      }))
    };

    const response = await PostRequest({
      url: apiEntradasGuardarTemporales,
      loader: "Guardando entrada en batch...",
      body,
    });

    if (response?.HasError || response?.hasError) {
      handleOpenAlert("Error al guardar entrada: " + (response?.message || ""));
      return false;
    }

    EntradasLocalService.limpiar();
    setTitleActionSave("EDITAR");
    handleOpenAlert("Entrada guardada correctamente", "OK");
    await handleObtenerDatosEntradas(folioEntrada, null, null, pcGuardar);
    return true;
  };

  const handleGuardarSalida = async (pcOverride, itemsOverride) => {
    const statusActual = (statusSalida || "").trim().toUpperCase();
    if (statusActual === "TR" || statusActual === "CA") {
      handleOpenAlert(
        statusActual === "CA"
          ? "La salida está cancelada, no se pueden guardar cambios"
          : "La salida está terminada, no se pueden guardar cambios"
      );
      return false;
    }

    const itemsLocalStorage = SalidasLocalService.cargar();
    const items = Array.isArray(itemsOverride) && itemsOverride.length > 0
      ? itemsOverride
      : itemsLocalStorage.length > 0
        ? itemsLocalStorage
        : listaSalidas;
    if (!items || items.length === 0) {
      handleOpenAlert("No hay artículos para guardar");
      return false;
    }

    if (isNullOrEmpty(almacenExhibidorSalida)) {
      handleOpenAlert("Seleccione un almacén/exhibidor");
      return false;
    }

    const pcGuardar = (pcOverride || parametrosCajaForm.caja || "").trim().toUpperCase();

    const body = {
      folio: folioSalida,
      concepto: conceptoSalida,
      almacenexhibidor: almacenExhibidorSalida,
      pc: pcGuardar,
      usuario: usuario,
      items: items.map(i => ({
        clavearticulo: i.clavearticulo || i.sClaveArticulo,
        descripcion: i.descripcion || i.sDescripcion || '',
        medida: i.medida ?? i.dMedida,
        cantidad: i.cantidadarticulo ?? i.dCantidadArticulo ?? i.cantidad ?? i.dCantidad ?? 0,
        pmvb: i.pmvb ?? i.dPMVB ?? 0,
        costoventa: i.costoventa ?? i.dCostoVenta ?? 0,
        almacenexhibidor: i.almacenexhibidor || i.sAlmacenExhibidor || almacenExhibidorSalida,
      }))
    };

    const response = await PostRequest({
      url: apiSalidasGuardarTemporales,
      loader: "Guardando salida en batch...",
      body,
    });

    if (response?.HasError || response?.hasError) {
      handleOpenAlert("Error al guardar salida: " + (response?.message || ""));
      return false;
    }

    SalidasLocalService.limpiar();
    setTitleActionSave("EDITAR");
    handleOpenAlert("Salida guardada correctamente", "OK");
    await handleObtenerDatosSalidas(folioSalida, null, null, pcGuardar);
    return true;
  };

  const guardarCantidadesLista = async (lista, tipo) => {
    if (!lista || lista.length === 0) return true;
    for (const item of lista) {
      const statusItem = (item.statusentradasalida || item.sStatusEntradaSalida || "").trim().toUpperCase();
      if (statusItem === "TR" || statusItem === "CA") continue;
      const body = {
        id: item.id,
        folioentradasalida: item.folioentradasalida || item.iFolioEntradaSalida,
        clavearticulo: item.clavearticulo || item.sClaveArticulo,
        medida: item.medida || item.dMedida,
        cantidad: item.cantidadarticulo,
        almacenexhibidor: item.almacenexhibidor || item.sAlmacenExhibidor,
        tipo,
        pc: item.pc || parametrosCajaForm.caja,
      };
      const response = await PostRequest({
        url: apiActualizarCantidadPartidaEntradaSalida,
        body,
      });
      if (response.HasError || !response?.result) {
        handleOpenAlert("Error al guardar cantidad: " + (response.message || ""));
        return false;
      }
    }
    return true;
  };

  const handleClickGuaredarEntrada = async () => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;

    // Rev 7: finado Redis (la ruta vieja con localStorage ya no se usa).
    if (titleActionSave === "GUARDAR") {
      if (!(await handleFlushEntradaRedis())) return;
    }
    await handleObtenerDatosEntradas(folioEntrada);
  };

  const handleClickGuaredarSalida = async () => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;

    // Rev 6: el finado ya recarga la lista mezclada (SQL + buffer).
    if (titleActionSave === "GUARDAR") {
      if (!(await handleFlushSalidaRedis())) return;
    }
  };

  const hendleEliminarPartidaEntradaSalida = async (partida, tipo) => {
    const tipoMovimiento = (tipo || "").toString().trim().toUpperCase();
    const statusMovimiento = tipoMovimiento === "ENTRADA"
      ? (statusEntrada || "").trim().toUpperCase()
      : (statusSalida || "").trim().toUpperCase();

    if (statusMovimiento === "TR" || statusMovimiento === "CA") {
      handleOpenAlert(`${tipoMovimiento === "ENTRADA" ? "Entrada" : "Salida"} ${statusMovimiento === "CA" ? "cancelada" : "terminada"}, no se pueden eliminar partidas`);
      return;
    }

    // Fila aún no guardada (id local negativo): se elimina solo del working set,
    // sin llamar al backend (ahí no existe y el batch que reemplaza la cuidaría igual).
    const idNum = Number(partida?.id);
    if (Number.isFinite(idNum) && idNum < 0) {
      try {
        if (tipoMovimiento === "ENTRADA") {
          const next = (listaEntradas || []).filter((i) => i.id !== partida.id);
          EntradasLocalService.guardar(next);
          setListaEntradas(next);
        } else {
          const next = (listaSalidas || []).filter((i) => i.id !== partida.id);
          SalidasLocalService.guardar(next);
          setListaSalidas(next);
        }
        // Rev 6: la partida también vive en el buffer Redis -> borrarla ahí
        // para que no reaparezca en la siguiente recarga o finado.
        await eliminarPartidaBufferRedis(tipoMovimiento, partida);
        setTitleActionSave("GUARDAR");
      } catch {}
      return;
    }

    // Rev 6: finar el buffer en SQL antes de eliminar la partida.
    if (titleActionSave === "GUARDAR") {
      if (tipoMovimiento === "ENTRADA") {
        if (!(await handleFlushEntradaRedis(partida?.pc))) return;
      } else {
        if (!(await handleFlushSalidaRedis(partida?.pc))) return;
      }
    }

    const response = await PostRequest({
      url: apiEliminarPartidaEntradaSalidaInventario.replace("{tipo}", tipo),
      body: partida,
      loader: "Se está eliminando la partida seleccionada",
    });

    if (response.HasError) {
      return;
    }

    if (response?.result) {
      setTitleActionSave("GUARDAR");
      const t = (tipo || "").toString().trim().toUpperCase();
      const pcPartida = partida.pc || parametrosCajaForm.caja;
      if (t === "ENTRADA") await handleObtenerDatosEntradas(partida.folioentradasalida, false, false, pcPartida);
      else if (t === "SALIDA") await handleObtenerDatosSalidas(partida.folioentradasalida, false, false, pcPartida);
    }
    else handleOpenAlert("No sé eliminó una partida " + response.message);
  };

  const hendleEliminarEntradaSalida = async (
    folio,
    tipo = "TODA LA ENTRADA",
    pcOverride
  ) => {
    const pcActual = pcOverride || parametrosCajaForm.caja;
    const tipoMovimiento = tipo.includes("ENTRADA") ? "ENTRADA" : "SALIDA";
    const statusMovimiento = tipoMovimiento === "ENTRADA"
      ? (statusEntrada || "").trim().toUpperCase()
      : (statusSalida || "").trim().toUpperCase();

    if (statusMovimiento === "TR" || statusMovimiento === "CA") {
      handleOpenAlert(`${tipoMovimiento === "ENTRADA" ? "Entrada" : "Salida"} ${statusMovimiento === "CA" ? "cancelada" : "terminada"}, no se puede eliminar`);
      return;
    }

    // Rev 6: finar el buffer en SQL antes de eliminar (el borrado posterior
    // limpia SQL + Redis en el backend).
    if (titleActionSave === "GUARDAR") {
      if (tipoMovimiento === "ENTRADA") {
        if (!(await handleFlushEntradaRedis(pcOverride))) return;
      } else {
        if (!(await handleFlushSalidaRedis(pcOverride))) return;
      }
    }

    if (tipo.includes("ENTRADA")) {
      EntradasLocalService.limpiar();
    } else {
      SalidasLocalService.limpiar();
    }

    let almacenActual = tipo.includes("ENTRADA") ? almacenExhibidor : almacenExhibidorSalida;
        
    // Si no hay almacen en el estado, intentar obtenerlo de la lista de entradas/salidas
    if (!almacenActual || almacenActual.trim() === "") {
      if (tipo.includes("ENTRADA") && listaEntradas && listaEntradas.length > 0) {
        almacenActual = listaEntradas[0].almacenexhibidor || listaEntradas[0].sAlmacenExhibidor || "";
      } else if (tipo.includes("SALIDA") && listaSalidas && listaSalidas.length > 0) {
        almacenActual = listaSalidas[0].almacenexhibidor || listaSalidas[0].sAlmacenExhibidor || "";
      }
    }

    const data = {
      folioentradasalida: folio,
      almacenexhibidor: almacenActual.trim().toUpperCase(),
      pc: pcActual,
    };

    let url = "";
    if (tipo.includes("ENTRADA")) {
      url = apiEliminarEntradaCompleta;
    } else {
      url = apiEliminarSalidaCompleta;
    }

    const response = await PostRequest({
      url: url,
      body: data,
      loader: "Eliminando movimiento completo...",
    });

    if (response.HasError) {
      handleOpenAlert("Error al eliminar: " + (response.message || "Error desconocido"));
      return;
    }

    if (response?.result) {
      if (tipo.includes("SALIDA")) {
        SalidasLocalService.limpiar();
        SalidasLocalService.limpiarSinExistencias();
      }
      if (tipo.includes("ENTRADA")) await handleObtenerDatosEntradas(folio, false, false, pcActual);
      else await handleObtenerDatosSalidas(folio, false, false, pcActual);
      // Cambiar título del botón a NUEVA después de eliminar entrada/salida completa
      if (tipo.includes("TODA LA")) {
        setTitleActionSave("NUEVA");
        setOpenModalBuscarArticulos(false);
      }
    }
    else
      handleOpenAlert("No se eliminó la entrada o salida: " + (response?.message || "Sin resultado"));
  };

  const handleActualizarCantidadPartidaEntrada = async (partida, nuevaCantidad) => {
    const statusEntradaActual = (statusEntrada || "").trim().toUpperCase();
    if (statusEntradaActual === "TR" || statusEntradaActual === "CA") {
      handleOpenAlert(statusEntradaActual === "CA"
        ? "Entrada cancelada, no se puede editar la cantidad"
        : "Entrada terminada, no se puede editar la cantidad");
      return false;
    }

    const updated = await new Promise(resolve => {
      setListaEntradas(prev => {
        const next = prev.map(item =>
          item.id === partida.id ? { ...item, cantidadarticulo: nuevaCantidad } : item
        );
        resolve(next);
        return next;
      });
    });

    EntradasLocalService.guardar(updated);
    setTitleActionSave("GUARDAR");
    return nuevaCantidad;
  };

  const handleActualizarCantidadPartidaSalida = async (partida, nuevaCantidad) => {
    const statusSalidaActual = (statusSalida || "").trim().toUpperCase();
    if (statusSalidaActual === "TR" || statusSalidaActual === "CA") {
      handleOpenAlert(statusSalidaActual === "CA"
        ? "Salida cancelada, no se puede editar la cantidad"
        : "Salida terminada, no se puede editar la cantidad");
      return false;
    }

    const clave = partida.clavearticulo || partida.sClaveArticulo;
    const medida = partida.medida || partida.dMedida;
    const almacen = almacenExhibidorSalida?.trim().toUpperCase();

    if (clave && medida && almacen) {
      try {
        const url = apiValidarStock
          .replace("{clavearticulo}", clave)
          .replace("{medida}", medida)
          .replace("{almacen}", almacen);

        const response = await GetRequest({ url });
        const existenciaDisponible = response?.result ?? 0;

        if (nuevaCantidad > existenciaDisponible) {
          handleOpenAlert(
            `Stock insuficiente. Existencia disponible: ${existenciaDisponible}. Se asignó la cantidad máxima disponible.`
          );
          nuevaCantidad = existenciaDisponible;
        }
      } catch {
        // Validación de stock opcional: si falla, se conserva la cantidad.
      }
    }

    setListaSalidas(prev => {
      const actualizada = prev.map(item =>
        item.id === partida.id ? { ...item, cantidadarticulo: nuevaCantidad } : item
      );
      SalidasLocalService.guardar(actualizada);
      return actualizada;
    });

    setTitleActionSave("GUARDAR");
    return nuevaCantidad;
  };

  const handleBuscarArticuloDescripcion = async () => {
    setStatusModalBuscadorArticulos(true);
  };

  const handleCloseBuscarArticuloDescripcion = async () => {
    setStatusModalBuscadorArticulos(false);
  };

  const handleCloseBuscarArticuloDescripcionTomaInventario = async () => {
    setStatusModalBuscadorArticulosTomaInventario(false);
  };

  const handleObtenerConceptosEntradas = async (tipo) => {
    const response = await GetRequest({
      url: apiObtenerListaConceptosEntradas,
      loader: "Cargando conceptos...",
    });

    if (response.HasError) {
      setListaConceptosEntrada([]);
      return;
    }

    const listaConceptos = response?.result;
    const lstConcep = [];
    for (let i = 0; i < listaConceptos.length; i++) {
      lstConcep.push({
        concepto: listaConceptos[i].trim().toUpperCase(),
        id: i,
      });
    }

    setListaConceptosEntrada(lstConcep);
  };

  const handleObtenerConceptosSalidas = async (tipo) => {
    const response = await GetRequest({
      url: apiObtenerListaConceptosSalidas,
      loader: "Cargando conceptos...",
    });

    if (response.HasError) {
      setListaConceptosSalidas([]);
      return;
    }

    const listaConceptos = response?.result;
    const lstConcep = [];
    for (let i = 0; i < listaConceptos.length; i++) {
      lstConcep.push({
        concepto: listaConceptos[i].trim().toUpperCase(),
        id: i,
      });
    }

    setListaConceptosSalida(lstConcep);
  };

  const handleObtenerAlmacenesExhibidores = async (tipo) => {
    const response = await GetRequest({
      url: apiListaAlmacenesExhibidores,
      loader: "Cargando almacenes/exhibidores del sistema...",
    });

    if (response.HasError) {
      if (tipo === "ENTRADA") {
        setListaAlmacenesExhibidoresEntrada([]);
      } else if (tipo === "SALIDA") {
        setListaAlmacenesExhibidoresSalida([]);
      } else {
        setListaAlmacenesExhibidoresGeneral([]);
      }
      return;
    }

    const listaAlmacenesExhibidores2 = response?.result ? response?.result : [];
    const lstAlmExhib = [];
    for (let i = 0; i < listaAlmacenesExhibidores2.length; i++) {
      lstAlmExhib.push({
        almacenexhibidor: listaAlmacenesExhibidores2[i].trim().toUpperCase(),
        nombre: listaAlmacenesExhibidores2[i].trim().toUpperCase(),
        id: i,
      });
    }

    if (tipo === "ENTRADA") {
      setListaAlmacenesExhibidoresEntrada(lstAlmExhib);
    } else if (tipo === "SALIDA") {
      setListaAlmacenesExhibidoresSalida(lstAlmExhib);
    } else {
      setListaAlmacenesExhibidoresGeneral(lstAlmExhib);
    }
  };

  const handleEliminarDataEntrada = (title, partida, pcOverride) => {
    switch (title) {
      case "ELIMINAR PARTIDA":
        hendleEliminarPartidaEntradaSalida(partida, "ENTRADA");
        break;
      case "ELIMINAR ENTRADA":
        hendleEliminarEntradaSalida(folioEntrada, "TODA LA ENTRADA", pcOverride);
        break;
    }
  };

  const handleEliminarDataSalida = (title, partida, pcOverride) => {
    switch (title) {
      case "ELIMINAR PARTIDA":
        hendleEliminarPartidaEntradaSalida(partida, "SALIDA");
        break;
      case "ELIMINAR SALIDA":
        hendleEliminarEntradaSalida(folioSalida, "TODA LA SALIDA", pcOverride);
        break;
    }
  };

  const handleChangeConcepto = (event, newValue) => {
    if (typeof newValue === "string") {
      setConceptoEntrada(newValue.trim().toUpperCase());
      return;
    }

    if (newValue && typeof newValue === "object") {
      setConceptoEntrada(
        String(newValue.concepto || "")
          .trim()
          .toUpperCase()
      );
      return;
    }

    setConceptoEntrada("");
  };

  const handleChangeConceptoSalida = (event, newValue) => {
    if (typeof newValue === "string") {
      setConceptoSalida(newValue.trim().toUpperCase());
      return;
    }

    if (newValue && typeof newValue === "object") {
      setConceptoSalida(
        String(newValue.concepto || "")
          .trim()
          .toUpperCase()
      );
      return;
    }

    setConceptoSalida("");
  };

  const handleChangeAlmacenexhibidor = (event, newValue) => {
    if (typeof newValue === "string") {
      setAlmacenExhibidor(newValue.trim().toUpperCase());
      return;
    }

    if (newValue && typeof newValue === "object") {
      setAlmacenExhibidor(
        String(newValue.nombre || "")
          .trim()
          .toUpperCase()
      );
      return;
    }

    setAlmacenExhibidor("");
  };

  const handleChangeAlmacenexhibidorSalida = (event, newValue) => {
    if (typeof newValue === "string") {
      setAlmacenExhibidorSalida(newValue.trim().toUpperCase());
      return;
    }

    if (newValue && typeof newValue === "object") {
      setAlmacenExhibidorSalida(
        String(newValue.nombre || "")
          .trim()
          .toUpperCase()
      );
      return;
    }

    setAlmacenExhibidorSalida("");
  };

  const handleClickRegresarMainDashboard = async () => {
    if (titleActionSave === "GUARDAR") {
      // Rev 6: finar buffers en SQL antes de salir.
      try {
        if (listaEntradas?.length > 0) await handleFlushEntradaRedis();
      } catch {}
      try {
        if (listaSalidas?.length > 0) await handleFlushSalidaRedis();
      } catch {}
      setTitleActionSave("NUEVA");
    }
    const route = "/*";
    navigation(route);
  };

  const handleImprimirEntradaMenu = async () => {
    await handleImprimirEntrada();
  };

  const handleImprimirEntrada = async (pcOverride) => {
    // Rev 6: finar el buffer en SQL antes de imprimir.
    if (titleActionSave === "GUARDAR") {
      if (!(await handleFlushEntradaRedis(pcOverride))) return;
    }

    const pc = pcOverride || parametrosCajaForm.caja.trim();
    const data = {
      folio: folioEntrada,
      tipo: "Entrada",
      pc: pc,
      tipousuario: tipoUsuario,
      usuario: usuario,
    };

    setStatusWaiting(true);
    await PostFileRequest({
      url: apiObtenerReporteEntradasSalidas,
      body: data,
      openInNewTab: true,
    });
    setStatusWaiting(false);
  };

  const handleImprimirSalida = async (pcOverride, cambiosGuardados = false) => {
    // Rev 6: finar el buffer en SQL antes de imprimir.
    if (titleActionSave === "GUARDAR" && !cambiosGuardados) {
      if (!(await handleFlushSalidaRedis(pcOverride))) return;
    }

    if (!(await guardarCantidadesLista(listaSalidas, "SALIDA"))) return;

    try {
      const pc = pcOverride || parametrosCajaForm.caja;
      const data = {
        folio: folioSalida,
        tipo: "Salida",
        pc: pc,
        tipousuario: tipoUsuario,
        usuario: usuario,
      };

      // Tenant: vía RequestContext para token JWE/JWT correcto (paridad con handleImprimirEntrada).
      setStatusWaiting(true);
      await PostFileRequest({
        url: apiObtenerReporteEntradasSalidas,
        body: data,
        openInNewTab: true,
      });
      setStatusWaiting(false);
    } catch (err) {
      setStatusWaiting(false);
      handleOpenAlert(`Error al generar PDF: ${err.message}`, "error");
    }
  };

  //Funcionalidad para cargar imagenes a memoria desde un <imput typefile="file" onChange={handleFileChange}>Cargar imagen</imput>
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1]; // solo el contenido
      setLogoBase64(base64String); // guarda en tu estado
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  //Obtener imágenes desde url de PNG a memoria
  function base64ToReaderResult(base64, mimeType = "image/png") {
    if (!base64 || typeof base64 !== "string") return null;
    return `data:${mimeType};base64,${base64}`;
  }

  const getImageBase64FromUrl = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1]; // Quitamos "data:image/png;base64,"
        resolve(base64String);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  function displayPDF(pdfString) {
    // Asegúrate de tener esta función definida en tu código
    if (typeof b64toBlob !== "function") {
      handleopenalert("Función b64toBlob no definida");
      return;
    }

    var file = b64toBlob(pdfString, "application/pdf");

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // Para Internet Explorer y Edge antiguos
      window.navigator.msSaveOrOpenBlob(file);
    } else {
      // Para navegadores modernos
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }
  }

  function b64toBlob(b64Data, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: contentType });
  }

  const handleCerrarImprimirEntrada = () => {
    setOpenModalImpresionEntradasSalidas(false);
  };

  const handleAplicarEntrada = async (pcOverride) => {
    const pcUsar = pcOverride || parametrosCajaForm.caja;

    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    if (isNullOrEmpty(folioEntrada)) {
      handleOpenAlert(`Es necesario cargar una entrada`);
      return;
    }

    if (isNullOrEmpty(conceptoEntrada)) {
      handleOpenAlert(`Es necesario cargar el concepto para continuar`);
      return;
    }

    const almacenNormalizado = almacenExhibidor?.trim().toUpperCase() || "";
    const almacenValido = listaAlmacenesExhibidoresEntrada.some(
      (item) => item.almacenexhibidor.trim().toUpperCase() === almacenNormalizado
    );

    if (!almacenValido) {
      handleOpenAlert(`El almacén/exhibidor "${almacenExhibidor}" no es válido. Seleccione uno de la lista.`);
      return;
    }

    const statusEntradaActual = (statusEntrada || "").trim().toUpperCase();
    if (statusEntradaActual === "TR" || statusEntradaActual === "CA") {
      handleOpenAlert(
        statusEntradaActual === "CA"
          ? `Entrada cancelada, no se puede aplicar`
          : `Entrada ya terminada, no se pueden registrar más articulos`
      );
      return;
    }

    if (titleActionSave === "GUARDAR") {
      handleOpenAlert(`Primero debe guardar los cambios antes de aplicar la entrada`);
      return;
    }

    let url = apiAplicarEntradaSalidaInventario.replace("{folio}",folioEntrada)
      .replace("{tipo}", "ENTRADA")
      .replace("{caja}", pcUsar.trim().toUpperCase());

    const response = await GetRequest({
      url,
      loader: "Se está aplicando entrada actual al inventario, aguarde un poco...",
    });

    if (response.HasError) {
      return;
    }

    if (response.result == null) {
      return;
    }

    if (response?.result) {
      handleOpenAlert(`Entrada aplicada correctamente`, "Alert");
      // Después de aplicar, restablecemos a la PC anfitriona
      const pcHost = parametrosCajaForm.caja.trim().toUpperCase();
      let folioDisponible = await handleObtenerFolioEntradaDisponible(pcHost);
      await handleObtenerDatosEntradas(folioDisponible);
      await handleCargarEntradas(folioDisponible);
      handleSincronizarExistenciasEntradas();
    } else {
      handleOpenAlert(`Entrada no aplicada...`, "error");
      await handleCargarEntradas();
    }
    setTitleActionSave("NUEVA");
    setOpenModalBuscarArticulos(false);
  };

  const handleAplicarSalida = async (pcOverride, cambiosGuardados = false) => {
    const pcUsar = pcOverride || parametrosCajaForm.caja;

    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    if (isNullOrEmpty(folioSalida)) {
      handleOpenAlert(`Es necesario cargar una salida`);
      return;
    }

    if (isNullOrEmpty(conceptoSalida)) {
      handleOpenAlert(`Es necesario cargar el concepto para continuar`);
      return;
    }

    const almacenNormalizado = almacenExhibidorSalida?.trim().toUpperCase() || "";
    const almacenValido = listaAlmacenesExhibidoresSalida.some(
      (item) => item.almacenexhibidor.trim().toUpperCase() === almacenNormalizado
    );
    if (!almacenValido) {
      handleOpenAlert(`El almacén/exhibidor "${almacenExhibidorSalida}" no es válido. Seleccione uno de la lista.`);
      return;
    }

    const statusSalidaActual = (statusSalida || "").trim().toUpperCase();
    if (statusSalidaActual === "TR" || statusSalidaActual === "CA") {
      handleOpenAlert(
        statusSalidaActual === "CA"
          ? `Salida cancelada, no se puede aplicar`
          : `Salida ya terminada, no se pueden registrar más articulos`
      );
      return;
    }

    if (titleActionSave === "GUARDAR" && !cambiosGuardados) {
      handleOpenAlert(`Primero debe guardar los cambios antes de aplicar la salida`);
      return;
    }

    let url = apiAplicarEntradaSalidaInventario.replace(
      "{folio}",
      folioSalida
    );
    url = url.replace("{tipo}", "SALIDA");
    url = url.replace("{caja}", pcUsar.trim().toUpperCase());
    const response = await GetRequest({
      url,
      loader:
        "Se está aplicando salida actual al inventario, aguarde un poco...",
    });

    if (response.HasError) return;

    if (response.result == null) return;

    if (response?.result) {
      handleOpenAlert(`Salida aplicada correctamente`, "Alert");
      // Después de aplicar, restablecemos a la PC anfitriona
      const pcHost = parametrosCajaForm.caja.trim().toUpperCase();
      let folioDisponible = await handleObtenerFolioSalidaDisponible(pcHost);
      await handleObtenerDatosSalidas(folioDisponible);
      await handleCargarSalidas(folioDisponible);
      handleSincronizarExistenciasFiltradas(listaSalidas, almacenExhibidorSalida);
    } else {
      handleOpenAlert(`Salida no aplicada...`, "error");
      await handleCargarSalidas();
    }
    setTitleActionSave("NUEVA");
    setOpenModalBuscarArticulos(false);
  };

  const handleCancelarEntradaSalida = async (tipo) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    const folioUsar = tipo?.includes("ENTRADA") ? folioEntrada : folioSalida;
    const statusUsar = tipo?.includes("ENTRADA") ? statusEntrada : statusSalida;
    if (isNullOrEmpty(folioUsar)) {
      handleOpenAlert(`Es necesario cargar una entrada/salida`);
      return;
    }

    if (isNullOrEmpty(conceptoEntrada)) {
      handleOpenAlert(`Es necesario cargar el concepto para continuar`);
      return;
    }

    if (statusUsar.trim().toUpperCase() === "TR") {
      handleOpenAlert(
        `Entrada/Salida ya terminada, no se pueden registrar más articulos`
      );
      return;
    }

    let url = apiCancelarEntradaSalida.replace("{tipo}", "ENTRADA");
    const response = await PostRequest({
      url,
      loader: "Se está realizando la cancelación de la entrada/salida",
    });

    if (response.HasError) {
      handleOpenAlert(`Error al cancelar la entrada/salida`, "error");
      return;
    }

    if (response.result == null) return;

    await handleObtenerDatosEntradas(folioUsar);
  };

  const handleCancelarEntrada = async () => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    if (isNullOrEmpty(folioEntrada)) {
      handleOpenAlert(`Es necesario cargar una entrada`);
      return;
    }

    if (isNullOrEmpty(almacenExhibidor)) {
      handleOpenAlert(`Es necesario cargar el almacén/exhibidor para continuar`);
      return;
    }

    if (statusEntrada.trim().toUpperCase() === "CA") {
      handleOpenAlert(`La entrada ya está cancelada`);
      return;
    }

    const response = await PostRequest({
      url: apiCancelarEntrada,
      body: {
        folioentradasalida: folioEntrada,
        almacenexhibidor: almacenExhibidor,
        pc: parametrosCajaForm.caja.trim().toUpperCase()
      },
      loader: "Cancelando entrada..."
    });

    if (response.HasError) {
      handleOpenAlert(`Error al cancelar la entrada: ${response.message}`, "error");
      return;
    }

    if (response.result == null) return;

    handleOpenAlert(`Entrada cancelada correctamente`, "Alert");
    setStatusEntrada("CA");
    setTitleActionSave("NUEVA");
    await handleObtenerDatosEntradas(folioEntrada);
  };

  const handleCancelarSalida = async () => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    if (isNullOrEmpty(folioSalida)) {
      handleOpenAlert(`Es necesario cargar una salida`);
      return;
    }

    if (isNullOrEmpty(almacenExhibidorSalida)) {
      handleOpenAlert(`Es necesario cargar el almacén/exhibidor para continuar`);
      return;
    }

    if (statusSalida.trim().toUpperCase() === "CA") {
      handleOpenAlert(`La salida ya está cancelada`);
      return;
    }

    const response = await PostRequest({
      url: apiCancelarSalida,
      body: {
        folioentradasalida: folioSalida,
        almacenexhibidor: almacenExhibidorSalida,
        pc: parametrosCajaForm.caja.trim().toUpperCase()
      },
      loader: "Cancelando salida..."
    });

    if (response.HasError) {
      handleOpenAlert(`Error al cancelar la salida: ${response.message}`, "error");
      return;
    }

    if (response.result == null) return;

    handleOpenAlert(`Salida cancelada correctamente`, "Alert");
    setStatusSalida("CA");
    setTitleActionSave("NUEVA");
    await handleObtenerDatosSalidas(folioSalida);
  };

  const handleIncrementarFolioEntrada = async () => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    let url = apiIncrementarFolioEntradas.replace(
      "{pc}",
      parametrosCajaForm.caja.trim().toUpperCase()
    );
    const response = await GetRequest({
      url,
      loadewr: "Se está incrementando el folio entradas de la caja ...",
    });

    if (response.HasError) return;

    if (response.result == null) return;

    if (response?.result) {
      handleOpenAlert(`Folio caja entrada incrementado...`, "Alerta");
    } else {
      handleOpenAlert(`No se ha podido incrementar el folio caja entradas...`);
    }
  };

  const handleIncrementarFolioSalidas = async () => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    let url = apiIncrementarFolioSalidas.replace(
      "{pc}",
      parametrosCajaForm.caja.trim().toUpperCase()
    );
    const response = await GetRequest({
      url,
      loadewr: "Se está incrementando el folio salidas de la caja ...",
    });

    if (response.HasError) return;

    if (response.result == null) return;

    if (response?.result) {
      handleOpenAlert(`Folio caja salidas incrementado...`, "Alerta");
    } else {
      handleOpenAlert(`No se ha podido incrementar el folio caja salidas...`);
    }
  };

  const handleObtenerStatusEntradaSalida = async (folio, pc, tipo) => {
    let url = apiStatusEntradaSalida.replace("{folio}", folio);
    url = url.replace("{pc}", pc);
    url = url.replace("{tipo}", tipo);
    const response = await GetRequest({
      url,
      loader: "Se está obteniendo el estatus de la entrada/salida",
    });

    if (response?.HasError) return "";

    return response?.result;
  };

  const handleClickNuevaGuardarEntrada = async (e) => {
    let title = e?.target?.innerText || titleActionSave;
    switch (title) {
      case "NUEVA":
        await handleClickNuevaEntrada();
        setTitleActionSave("GUARDAR");
        break;
      case "GUARDAR":
        // Rev 6: el finado Redis deja EDITAR solo si se guardó (si falla,
        // conserva GUARDAR para reintentar).
        await handleFlushEntradaRedis();
        break;
    }
  };

  const handleClickNuevaGuardarSalida = async (e) => {
    let title = e?.target?.innerText || titleActionSave;
    switch (title) {
      case "NUEVA":
        await handleClickNuevaSalida();
        setTitleActionSave("GUARDAR");
        break;
      case "GUARDAR":
        // Rev 6: el finado Redis deja EDITAR solo si se guardó.
        await handleFlushSalidaRedis();
        break;
    }
  };

  const handleClickEditarGuardarEntrada = async () => {
    const statusActual = (statusEntrada || "").trim().toUpperCase();
    if (statusActual === "TR" || statusActual === "CA") {
      setTitleActionSave("EDITAR");
      return;
    }
    setTitleActionSave("GUARDAR");
  };

  const handleClickNuevaEntradaButton = async () => {
    if (titleActionSave === "GUARDAR") {
      // Rev 6: finar antes de nueva (aborta si falla).
      if (!(await handleFlushEntradaRedis())) return;
    }
    await handleClickNuevaEntrada();
    setTitleActionSave("GUARDAR");
  };

  const handleClickEditarGuardarSalida = async () => {
    const statusActual = (statusSalida || "").trim().toUpperCase();
    if (statusActual === "TR" || statusActual === "CA") {
      setTitleActionSave("EDITAR");
      return;
    }
    setTitleActionSave("GUARDAR");
  };

  const handleClickNuevaSalidaButton = async () => {
    if (titleActionSave === "GUARDAR") {
      // Rev 6: finar antes de nueva (aborta si falla).
      if (!(await handleFlushSalidaRedis())) return;
    }
    await handleClickNuevaSalida();
    setTitleActionSave("GUARDAR");
  };

  const handleCloseModarBuscarEntradaSalida = () => {
    setOpenModarlBuscarEntradaSalida(false);
  };

  const handleOpenModalBuscarEntradaSalida = () => {
    setOpenModarlBuscarEntradaSalida(true);
  };

  const handleObtenerExistenciasAlmacenExhibidor = async (
    filtro,
    almacenexhibidor,
    corrida = ""
  ) => {
    if (isNullOrEmpty(filtro) || isNullOrEmpty(almacenexhibidor)) {
      return;
    }

    // Corrida opcional: misma rutina que Artículos (se manda la descripción y
    // el backend resuelve medidainicial/medidafinal para limitar las medidas).
    const corridaTrim = (corrida || "").trim();

    const data = {
      filtro: filtro.trim(),
      almacenexhibidor: almacenexhibidor.trim(),
      ...(corridaTrim ? { corrida: corridaTrim } : {}),
    };

    const isFull = almacenexhibidor.trim().toUpperCase() === "FULL";
    const urlApi = isFull ? apiFiltroExistenciasFull : apiFiltroExistenciasAlmacenExhibidor;

    const response = await PostRequest({
      url: urlApi,
      body: data,
      loader: isFull ? "Cargando existencias consolidadas FULL..." : "Se están cargando las existencias...",
    });

    if (response.HasError) {
      setDataFiltroExistencias([]);
      return;
    }

    // Convertir foto de cada artículo a data URL para mostrar en tooltip
    const dataConFotos = (response?.result || []).map(articulo => {
      const rawFoto = articulo.foto || articulo.imagen || articulo.Foto || articulo.Imagen || articulo.FOTO || articulo.IMAGEN;
      const fotoData = rawFoto ? base64ToReaderResult(rawFoto) : null;
      return {
        ...articulo,
        foto: fotoData
      };
    });

    setDataFiltroExistencias(dataConFotos);
    return response?.result;
  };

  const handleObtenerExistenciasAlmacenExhibidorEtiquetado = async (
    filtro,
    almacenexhibidor
  ) => {
    if (isNullOrEmpty(filtro) || isNullOrEmpty(almacenexhibidor)) {
      return;
    }

    const data = {
      filtro: filtro.trim(),
      almacenexhibidor: almacenexhibidor.trim(),
    };

    const response = await PostRequest({
      url: apiFiltroExistenciasAlmacenExhibidor,
      body: data,
      loader: "Se están cargando las existencias...",
    });

    if (response.HasError) {
      setDataArticuloFiltroEtiquetado([]);
      return;
    }

    // Convertir foto de cada artículo a data URL para mostrar en tooltip
    const dataConFotos = (response?.result || []).map(articulo => {
      const rawFoto = articulo.foto || articulo.imagen || articulo.Foto || articulo.Imagen || articulo.FOTO || articulo.IMAGEN;
      return {
        ...articulo,
        foto: rawFoto ? base64ToReaderResult(rawFoto) : null
      };
    });

    setDataArticuloFiltroEtiquetado(dataConFotos);
    return response?.result;
  };

  const handleObtenerKardexArticulo = async () => {
    if (tipoUsuario === "USUARIO") {
      handleOpenAlert(
        "No tiene permisos sificientes para obtener este reporte"
      );
      return;
    }

    if (isNullOrEmpty(claveArticulo) || isNullOrEmpty(medida)) {
      handleOpenAlert("Tiene que seleccionar una medida para cargar el kardex");
      return;
    }

    const urlSend = apiKardexArticulos
      .replace("{clavearticulo}", claveArticulo.trim())
      .replace("{medida}", medida);

    setStatusWaiting(true);
    await GetFileRequest({ url: urlSend, openInNewTab: true });
    setStatusWaiting(false);
  };

  const handleCargarTrasladosPC = async () => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    const url = apiTrasladosList.replace(
      "{pc}",
      parametrosCajaForm.caja.trim()
    );
    const result = await GetRequest({
      url,
      loader: "Cargando lista de traslados de la caja...",
    });

    if (result.HasError) {
      setListaTrasladosData([]);
      return;
    }

    setListaTrasladosData(result?.result || []);
  };

  const handleRegistrarTrasladosPC = async (dataArticulo) => {
    
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;

    const origen = getTrasladoAlmacenActual('traslado_almacenOrigen');
    const destino = getTrasladoAlmacenActual('traslado_almacenDestino');

    if (!origen?.nombre || !destino?.nombre) {
      handleOpenAlert("Es necesario seleccionar almacén origen y destino");
      return;
    }

    const nomOrigen = origen.nombre.trim();
    const nomDestino = destino.nombre.trim();
    const nomOrigenUpper = nomOrigen.toUpperCase();
    const nomDestinoUpper = nomDestino.toUpperCase();
    const origenValido = listaAlmacenesExhibidoresGeneral.some(
      (item) => item.almacenexhibidor.toUpperCase() === nomOrigenUpper
    );
    const destinoValido = listaAlmacenesExhibidoresGeneral.some(
      (item) => item.almacenexhibidor.toUpperCase() === nomDestinoUpper
    );

    if (!origenValido) {
      handleOpenAlert(`El almacén origen "${nomOrigen}" no es válido.`);
      return;
    }
    if (!destinoValido) {
      handleOpenAlert(`El almacén destino "${nomDestino}" no es válido.`);
      return;
    }
    if (nomOrigenUpper === nomDestinoUpper) {
      handleOpenAlert("El almacén origen y destino no pueden ser iguales");
      return;
    }
    if (!dataArticulo) return;

    if (!dataArticulo.medida || !dataArticulo.factor) {
      handleOpenAlert("Error en datos para traslado");
      return;
    }

    const data = {
      pc: parametrosCajaForm.caja.trim(),
      clavearticulo: dataArticulo.clavearticulo.trim(),
      descripcion: dataArticulo.descripcion.trim(),
      medida: dataArticulo.medida,
      almacenexhibidororigen: nomOrigen,
      almacenexhibidordestino: nomDestino || parametrosCajaForm.dominio.trim().toUpperCase(),
      usuario: usuario,
      cantidad: dataArticulo.factor,
    };

    const result = await PostRequest({
      url: apiTrasladosRegistrar,
      body: data,
      loader: "Registrando artículo en traslado...",
    });

    if (result.hasError) {
      const existenciaData = await handleObtenerExistenciasAlmacenExhibidor(
        dataArticulo.clavearticulo,
        nomOrigen
      );

      let existenciaReal = 0;
      if (Array.isArray(existenciaData)) {
        const articulo = existenciaData.find(a =>
          (a.sClaveArticulo || a.clavearticulo || "").trim() === dataArticulo.clavearticulo.trim()
        );
        if (articulo && articulo.lMedidas) {
          const medidaObj = articulo.lMedidas.find(m => m.sMedida === dataArticulo.medida);
          existenciaReal = medidaObj ? medidaObj.dExistencia : 0;
        }
      }

      speakText(`Artículo ${data.descripcion || "artículo"} sin existencias`);
      setDataArticuloSinExistencia({
        clavearticulo: dataArticulo.clavearticulo,
        descripcion: dataArticulo.descripcion,
        medida: dataArticulo.medida,
        existencia: existenciaReal,
        almacenorigen: nomOrigen,
      });
      setOpenModalAlertaSinExistencia(true);
      return;
    }

    handleCargarTrasladosPC();
  };

  const handleAplicarTrasladoPC = async (e, pc) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;

    const origen = getTrasladoAlmacenActual('traslado_almacenOrigen');
    const destino = getTrasladoAlmacenActual('traslado_almacenDestino');

    if (!origen?.nombre || !destino?.nombre) {
      handleOpenAlert("Es necesario seleccionar almacén origen y destino");
      return;
    }

    const nomOrigen = origen.nombre.trim();
    const nomDestino = destino.nombre.trim();
    const nomOrigenUpper = nomOrigen.toUpperCase();
    const nomDestinoUpper = nomDestino.toUpperCase();

    const origenValido = listaAlmacenesExhibidoresGeneral.some(
      (item) => item.almacenexhibidor.toUpperCase() === nomOrigenUpper
    );
    const destinoValido = listaAlmacenesExhibidoresGeneral.some(
      (item) => item.almacenexhibidor.toUpperCase() === nomDestinoUpper
    );

    if (!origenValido) {
      handleOpenAlert(`El almacén origen "${nomOrigen}" no es válido.`);
      return;
    }
    if (!destinoValido) {
      handleOpenAlert(`El almacén destino "${nomDestino}" no es válido.`);
      return;
    }
    if (nomOrigenUpper === nomDestinoUpper) {
      handleOpenAlert("El almacén origen y destino no pueden ser iguales");
      return;
    }

    //Imprimir traslado pdf en pantalla
    await handleImprimirTraslado(pc);

    const url = apiTrasladosAplicar.replace("{pc}", pc.trim());
    const result = await GetRequest({
      url,
      loader: `Se está aplicando el traslado desde pc ${pc.trim()}...`,
    });

    if (result.hasError) {
      setListaTrasladosData([]);
      return;
    }

    handleCargarTrasladosPC();
    handleSincronizarExistenciasFiltradas(listaTrasladosData, almacenExhibidorDestino);
    setIsTrasladoBlocked(true);
  };

  const handleClickDeletePartida = async (e, row) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    if (listaTrasladosData.length === 0) {
      return;
    }

    const url = apiTrasladosEliminaPartida
      .replace("{pc}", row.pc.trim())
      .replace("{id}", row.id);
    const result = await DeleteRequest({
      url,
      loader: "Se está eiminando la partida del traslado...",
    });

    if (result.hasError) {
      handleOpenAlert(
        "Error al eliminar partida del traslado: " + (result.message || "")
      );
      return;
    }
    handleCargarTrasladosPC();
  };

  const handleClickDeleteTraslado = async (pc) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    if (listaTrasladosData.length === 0) {
      return;
    }

    if (isNullOrEmpty(pc)) return;

    const url = apiTrasladosEliminaTrasladoPC.replace("{pc}", pc.trim());
    const result = await DeleteRequest({
      url,
      loader: "Se está eliminando el traslado...",
    });

    if (result.hasError) {
      handleOpenAlert("Error al eliminar el traslado: " + (result.message || ""));
      return;
    }
    handleCargarTrasladosPC();
  };

  const handleClickNuevoTraslado = async (pc) => {
    if (isNullOrEmpty(pc)) return;

    if (listaTrasladosData.length > 0) {
      await handleClickDeleteTraslado(pc);
    }

    setIsTrasladoBlocked(false);
  };

  const handleImprimirTraslado = async (pc) => {
    if (!listaTrasladosData.length > 0) return;

    const urlSend = apiImprimirTraslado.replace("{pc}", pc.trim());
    setStatusWaiting(true);
    await GetFileRequest({ url: urlSend, openInNewTab: true });
    setStatusWaiting(false);
  };

  // Rev 25/09/2026: historial del día alineado a reportes por periodo.
  // El obsoleto GET .../traslados/imprimirhistorialdia devuelve 404, así que
  // se genera vía POST .../traslados/reporteperiodo (mismo decorador, sin
  // ajuste de nginx) desde los temporales/SQL finados por FechaRegistro
  // (todos los movimientos del día).
  const handleImprimirTrasladoHistorialDia = async (filtros = {}) => {
    const hoy = new Date();
    const pad = (n) => String(n).padStart(2, "0");
    const fechaHoy = `${hoy.getFullYear()}-${pad(hoy.getMonth() + 1)}-${pad(hoy.getDate())}`;
    const body = {
      fechainicio: filtros.fechainicio || fechaHoy,
      fechafin: filtros.fechafin || filtros.fechainicio || fechaHoy,
      almacenorigen: String(filtros.almacenorigen || filtros.almacen || "TODOS").trim().toUpperCase() || "TODOS",
      almacendestino: String(filtros.almacendestino || "TODOS").trim().toUpperCase() || "TODOS",
      filtrodescripcion: String(filtros.filtrodescripcion || "").trim().toUpperCase(),
      sucursal: parametrosCajaForm?.sucursal ?? "",
      pc: (parametrosCajaForm?.caja || "").trim(),
      usuario: usuario || "",
      tipousuario: tipoUsuario || "USUARIO",
    };
    setStatusWaiting(true);
    try {
      await PostFileRequest({
        url: apiReporteTrasladosPeriodo,
        body,
        filename: `ReporteTraslados-${body.fechainicio}-${body.fechafin}.pdf`,
        openInNewTab: true,
        loader: "Cargando reporte...",
      });
    } finally {
      setStatusWaiting(false);
    }
  };

  const handleCloseModalBuscarArticulos = () => {
    setOpenModalBuscarArticulos(false);
  };

  const handleAbrirModalBuscarArticulos = () => {
    setOpenModalBuscarArticulos(true);
  };

  const [dataArticulo, setDataArticulo] = useState({});
  const handleBuscarArticuloFullData = async (barcode) => {
    const response = await GetRequest({
      url: apiBuscarArticuloPorCodigoBarras.replace("{codigobarras}", barcode),
      alert: "Buscando artículo por código de barras",
    });

    if (response.HasError) {
      setDataArticulo({});
      return;
    }

    setDataArticulo(response?.result);
    return response?.result;
  };

  const handleClickNuevoEtiquetado = async () => {
    await handleEliminaEtiquetadoCompleto();
    setDataArticuloEtiquetar([]);
    setDataArticuloFiltroEtiquetado([]);
    setCantidadesEtiquetado({});
    setStatusEnableFieldsEtiquetado(false);
  };

  const handleCancelarEtiquetado = async () => {
    await handleEliminaEtiquetadoCompleto();
    setDataArticuloEtiquetar([]);
    setDataArticuloFiltroEtiquetado([]);
    setCantidadesEtiquetado({});
    setStatusEnableFieldsEtiquetado(true);
  };

  const handleChangeRowFiltroEtiquetar = (e) => {
    setArticuloFiltro(e);
  };

  const handleChangeRowEtiquetar = (e) => {
    setArticuloEtiquetar(e);
  };

  const handleGetListEtiqetado = async (almacenParam) => {
    const almacen =
      (almacenParam || almacenExhibidorEtiquetado || parametrosCajaForm.dominio || "").trim();
    const pc = (parametrosCajaForm.caja || "").trim();

    const dataIntegracion = {
      almacenexhibidor: almacen,
      pc,
      medida: 0,
      clavearticulo: "",
      descripcion: "",
      cantidad: 0,
    };

    try {
      const result = await PostRequest({
        url: apiGetListEtiquetado,
        body: dataIntegracion,
        alert: "Obteniendo lista de etiquetado...",
      });

      if (!result || result.HasError) {
        setDataArticuloEtiquetar([]);
        setCantidadesEtiquetado({});
        handleOpenAlert(result?.message || "Sin datos");
        return;
      }

      const lista = result.result ?? [];

      // ==============================
      // 1) AGRUPAR POR CLAVEARTICULO
      // ==============================
      const articulosMap = {};
      const cantidades = {};

      lista.forEach((item) => {
        const key = item.clavearticulo;

        // Crear artículo si no existe
        if (!articulosMap[key]) {
          articulosMap[key] = {
            id: key, // usamos la clave como ID único
            clavearticulo: item.clavearticulo,
            descripcion: item.descripcion,
            listamedidas: [],
          };
        }

        // Agregar la medida (evitar duplicados)
        articulosMap[key].listamedidas.push({
          medida: item.medida,
          codigobarras: item.codigobarras || "",
          existencia: item.existencia ?? 0,
        });

        // Cantidades
        if (!cantidades[key]) cantidades[key] = {};
        cantidades[key][item.medida] = item.cantidad || 0;
      });

      // Convertir map a array
      const listaArticulos = Object.values(articulosMap);

      // ==============================
      // 2) ACTUALIZAR ESTADOS
      // ==============================
      setDataArticuloEtiquetar(listaArticulos);
      setCantidadesEtiquetado(cantidades);

      if (listaArticulos.length > 0) {
        setStatusEnableFieldsEtiquetado(false);
      }
    } catch (err) {
      setDataArticuloEtiquetar([]);
      setCantidadesEtiquetado({});
      handleOpenAlert(err?.message || "Error desconocido");
    }
  };

  const handleCambiarAlmacenEtiquetado = async (almacenNuevo, almacenActual) => {
    const pc = (parametrosCajaForm.caja || "").trim();
    const almacenAnterior = (almacenActual || "").trim();
    if (!pc || !almacenNuevo) {
      handleOpenAlert("PC y nuevo almacén son obligatorios");
      return false;
    }

    try {
      const result = await PostRequest({
        url: apiCambiarAlmacenEtiquetado,
        body: {
          almacenuevo: almacenNuevo.trim().toUpperCase(),
          pc: (pc || "").trim().toUpperCase(),
          almacenanterior: (almacenAnterior || "").trim().toUpperCase(),
        },
        alert: "Actualizando almacén de etiquetado...",
      });

      if (result?.HasError) {
        handleOpenAlert(result?.message || "Error al cambiar almacén de etiquetado");
        return false;
      }

      handleOpenAlert("Almacén de etiquetado actualizado correctamente", "OK");
      return true;
    } catch (err) {
      handleOpenAlert(err?.message || "Error al cambiar almacén de etiquetado", "error");
      return false;
    }
  };

  const idEtiquetaRef = useRef(1);
  const handleAgregarAEtiquetado = async (articulo) => {
    if (!articulo) return;
    if (!articulo.listamedidas) return;

    const dataIntegracion = {
      almacenexhibidor:
        (almacenExhibidorEtiquetado || parametrosCajaForm.dominio || "").trim(),
      pc: (parametrosCajaForm.caja || "").trim(),
      clavearticulo: (articulo.clavearticulo || "").trim(),
    };

    const result = await PostRequest({
      url: apiAgregarEtiquetado,
      body: dataIntegracion,
      alert: "Agregando artículo al etiquetado...",
    });

    handleOpenAlert(result?.message || "Artículo agregado al etiquetado", result?.HasError ? "error" : "OK");

    // Verificar si ya existe el artículo en la lista
    if (result.HasError) {
      handleOpenAlert(result?.message || "Error al agregar artículo");
      return;
    }

    handleGetListEtiqetado();
  };

  const handleEliminaPartidaEtiquetado = async (articulo) => {
    if (!articulo) return;

    const idArticulo = articulo.id;

    const dataIntegracion = {
      almacenexhibidor: (almacenExhibidorEtiquetado || parametrosCajaForm.dominio || "").trim(),
      pc: (parametrosCajaForm.caja || "").trim(),
      clavearticulo: (articulo.clavearticulo || "").trim(),
    };

    try {
      const result = await PostRequest({
        url: apiEliminarPartidaEtiquetado,
        body: dataIntegracion,
        alert: "Eliminando partida del etiquetado...",
      });

      if (!result || result.HasError) {
        handleOpenAlert(result?.message || "Error al eliminar partida");
        return;
      }

      setDataArticuloEtiquetar((prev) => prev.filter((a) => a.id !== idArticulo));

      setCantidadesEtiquetado((prev) => {
        const copia = { ...prev };
        delete copia[idArticulo];
        return copia;
      });

      setArticuloEtiquetar((prev) =>
        prev && prev.id === idArticulo ? null : prev
      );

      // Refrescamos la lista desde la base de datos
      await handleGetListEtiqetado();
    } catch (err) {
      handleOpenAlert(err?.message || "Error desconocido en eliminación");
    }
  };

  const handleEliminaEtiquetadoCompleto = async () => {
    const dataIntegracion = {
      almacenexhibidor: (almacenExhibidorEtiquetado || parametrosCajaForm.dominio || "").trim(),
      pc: (parametrosCajaForm.caja || "").trim(),
      medida: 0,
      clavearticulo: "",
      descripcion: "",
      cantidad: 0,
    };

    try {
      const result = await PostRequest({
        url: apiLimpiarEtiquetado,
        body: dataIntegracion,
        alert: "Error al eliminar etiquetado completo...",
      });

      if (!result || result.HasError) {
        handleOpenAlert(result?.message || "Sin datos");
        return;
      }

      setDataArticuloEtiquetar([]);
      setCantidadesEtiquetado({});
      setArticuloEtiquetar(null);
    } catch (err) {
      handleOpenAlert(err?.message || "Error desconocido");
    }
  };

  const handleImprimirEtiquetas = async ({
    dataArticulos = dataArticuloEtiquetar,
    cantidades = cantidadesEtiquetado,
    almacen = almacenExhibidorEtiquetado,
    integrar = integrarInventario,
    parametros = parametrosCajaForm,
  } = {}) => {

    if (!parametros || parametros.caja === "CAJA-DEFAULT") {
      handleOpenAlert("Caja no configurada");
      return;
    }

    const data = buildLineasEtiquetas({
      dataArticulos,
      cantidades,
      almacen,
      parametros,
    });

    // Validar que venga un arreglo con líneas de impresión
    if (!Array.isArray(data) || data.length === 0) {
      handleOpenAlert("No hay etiquetas por imprimir");
      return;
    }

    // Nombre de impresora Zebra (puedes usar uno específico o el mismo de ventas)
    let printerName = parametros?.nombreimpresoraetiqueta?.trim() || "";
    if (!printerName) {
      printerName = localStorage.getItem('nombreimpresoraetiqueta') || "";
    }

    if (!printerName) {
      handleOpenAlert("No se encontró la impresora de etiquetas configurada. Configure la impresora en Parámetros de Caja.");
      return;
    }
    if (printerName) {
      localStorage.setItem('nombreimpresoraetiqueta', printerName);
    }

    // Si está activo integrarInventario, mostrar modal de confirmación
    if (integrar) {
      setOpenModalConfirmIntegrar(true);
      return;
    }

    // Si no está activo, ejecutar directamente
    await ejecutarImpresionYIntegracion({
      dataLineas: data,
      printerName,
      almacen,
      integrar,
      parametros,
    });
  };

  const ejecutarImpresionYIntegracion = async ({
    dataLineas: data,
    printerName: printerNameParam,
    almacen: almacenParam,
    integrar: integrarParam,
    parametros: parametrosParam,
  } = {}) => {
    try {
      const dataLineasImpresion = data || buildLineasEtiquetas({
        dataArticulos: dataArticuloEtiquetar,
        cantidades: cantidadesEtiquetado,
        almacen: almacenExhibidorEtiquetado,
        parametros: parametrosCajaForm,
      });

      let printerName = printerNameParam || parametrosCajaForm?.nombreimpresoraetiqueta?.trim() || "";
      if (!printerName) {
        printerName = localStorage.getItem('nombreimpresoraetiqueta') || "";
      }
      if (!printerName) {
        handleOpenAlert("No se encontró la impresora de etiquetas configurada. Configure la impresora en Parámetros de Caja.");
        return;
      }

      let integracionExitosa = true;

      const almacenParaIntegrar = almacenParam || almacenExhibidorEtiquetado ||
        (typeof window !== 'undefined' ? localStorage.getItem('etiquetado_almacenExhibidor') : '') ||
        parametrosCajaForm.dominio || "";

      const pcParaEnviar = (parametrosParam?.caja || parametrosCajaForm.caja || "").trim();
      const almacenParaEnviar = (almacenParaIntegrar || "").trim();

      if (integrarParam ?? integrarInventario) {
        for (const linea of dataLineasImpresion) {
          const dataIntegracion = {
            almacenexhibidor: almacenParaEnviar,
            clavearticulo: linea.clavearticulo,
            descripcion: linea.descripcionArticulo,
            medida: Number(linea.medida) || 0,
            cantidad: Number(linea.totalEtiquetas) || 0,
            pc: pcParaEnviar,
            codigobarras: linea.codigoBarras || "",
          };

          var resultIntegracion = await PostRequest({
            url: apiIntegrarEtiquetadoInventario,
            body: dataIntegracion,
            alert: "Integrando a inventarios...",
          });

          if (resultIntegracion.HasError) {
            handleOpenAlert(`Error en integración al inventario: ${resultIntegracion.message}`);
            integracionExitosa = false;
          }
        }
      }

      let impresionExitosa = true;
      for (const linea of dataLineasImpresion) {
        const { totalEtiquetas, descripcionArticulo, medida, codigoBarras } = linea;

        const total = Number(totalEtiquetas) || 0;
        if (total <= 0) continue;

        const formData = new FormData();
        formData.append("total_etiquetas", total);
        formData.append("printerName", printerName);
        formData.append("descripcion_articulo", descripcionArticulo);
        formData.append("medida", medida);
        formData.append("codigo_barras", codigoBarras);

        const response = await fetch(
          `http://localhost:4000/api/imprimiretiquetas`,
          { method: "POST", body: formData }
        );

        if (!response.ok) {
          const text = await response.text().catch(() => response.statusText);
          handleOpenAlert(`Error en impresión: ${text}`, "error");
          impresionExitosa = false;
        }

        await new Promise(resolve => setTimeout(resolve, 1000));
      }

      if (impresionExitosa) {
        handleOpenAlert("Impresión de etiquetas realizada", "OK");
      }
      if ((integrarParam ?? integrarInventario) && integracionExitosa) {
        handleOpenAlert("Integración al inventario realizada", "OK");
      }
    } catch (err) {
      handleOpenAlert(err?.message || "Error desconocido en proceso de etiquetado", "error");
    } finally {
      try {
        await handleEliminaEtiquetadoCompleto();
      } catch {
        // Limpieza opcional al finalizar etiquetado.
      }

      setDataArticuloEtiquetar([]);
      setDataFiltroExistencias([]);
      setDataArticuloFiltroEtiquetado([]);
      setCantidadesEtiquetado({});
      setArticuloEtiquetar(null);
      setStatusEnableFieldsEtiquetado(true);

      handleOpenAlert("Proceso de etiquetado completado", "OK");
    }
  };

  const buildLineasEtiquetas = ({
    dataArticulos = dataArticuloEtiquetar,
    cantidades = cantidadesEtiquetado,
    almacen = almacenExhibidorEtiquetado,
    parametros = parametrosCajaForm,
  } = {}) => {

    const lineas = [];

    (dataArticulos || []).forEach((articulo) => {
      const idArticulo = articulo.id;
      const tallasArticulo = cantidades?.[idArticulo];
      const listaMedidas = articulo.listamedidas || [];

      if (
        !tallasArticulo ||
        !Array.isArray(listaMedidas) ||
        listaMedidas.length === 0
      )
        return;

      // Ordenar las medidas correctamente: 22, 22.5, 23, 23.5...
      const medidasOrdenadas = [...listaMedidas].sort((a, b) => parseFloat(a.medida) - parseFloat(b.medida));

      medidasOrdenadas.forEach((medidaObj) => {
        const medida = String(medidaObj.medida);
        const cantidad = tallasArticulo[medida];
        const total = Number(cantidad) || 0;
        if (total <= 0) return;

        const codigoBarras = medidaObj?.codigobarras || "";

        lineas.push({
          almacenexhibidor: (almacen || parametros?.dominio || "").trim(),
          pc: (parametros?.caja || "").trim(),
          clavearticulo: articulo.clavearticulo || "",
          descripcionArticulo: articulo.descripcion || "",
          medida: medida,
          totalEtiquetas: total,
          codigoBarras,
        });
      });
    });

    return lineas;
  };

  const handleChangeCantidadEtiquetado = async (idArticulo, medida, value) => {
    setCantidadesEtiquetado((prev) => ({
      ...prev,
      [idArticulo]: {
        ...(prev[idArticulo] || {}),
        [medida]: value,
      },
    }));

    if (
      isNullOrEmpty(idArticulo) ||
      isNullOrEmpty(medida) ||
      medida === 0 ||
      value === "" ||
      value < 0
    ) {
      return;
    }

    // 2) Localizamos el artículo (primero en filtrados, si no, en la lista de etiquetado)
    const articulo =
      dataArticuloFiltroEtiquetado.find((a) => a.id === idArticulo) ||
      dataArticuloEtiquetar.find((a) => a.id === idArticulo) ||
      {};

    // 3) Armamos el payload EXACTO que espera EntEtiquetado
    const dataIntegracion = {
      almacenexhibidor: (almacenExhibidorEtiquetado || parametrosCajaForm.dominio || "").trim(),
      pc: (parametrosCajaForm.caja || "").trim(),
      medida: Number(medida) || 0, // fMedida (float)
      descripcion: articulo.descripcion || "", // sDescripcion
      cantidad: Number(value) || 0, // fCantidad (float)
      clavearticulo: articulo.clavearticulo || "", // sClaveArticulo
    };

    handleOpenAlert(`Actualizando cantidad de etiquetas para ${articulo.descripcion} medida ${medida}...`, "Alert");

    const resultIntegracion = await PostRequest({
      url: apiUpdateEtiquetado,
      body: dataIntegracion, // <- aquí ya NO va { dataIntegracion }
      alert: "Registrando/Actualizando etiqueta en lista de etiquetado...",
    });

    if (!resultIntegracion || resultIntegracion.HasError) {
      handleOpenAlert(
        `Error al actualizar la cantidad de etiquetas copias por medida: ${resultIntegracion?.message || "Error en la respuesta del servidor"
        }`
      );
      return;
    }

    // 4) Refrescamos la lista de etiquetado
    await handleGetListEtiqetado();
  };

  const handleTomaReset = () => {
    setTomaHeader(getDataTomaInventarioHeader());
    setTomaDetalle([]);
    setTomaZonasDiff([]);
  };

  const handleTomaCargarActivo = async () => {
    const resp = await GetRequest({
      url: apiTomaInventarioActivo,
      loader: "Verificando inventario activo...",
    });
    if (resp.HasError || !resp.result) return false;

    const folioActivo = resp.result.folioinventario;
    if (folioActivo && folioActivo > 0) {
      await handleTomaLoadAll(folioActivo);
      return true;
    }
    return false;
  };

  const handleTomaLoadAll = async (folio) => {
    if (!folio || folio <= 0) return;
    // NO limpiar el filtro aquí - se mantiene hasta que el usuario oprima "Limpiar"
    // Solo limpiar al cargar un inventario diferente (no al recargar el mismo)

    // Header
    let urlH = apiTomaInventarioGetHeader.replace("{folioinventario}", folio);
    const respH = await GetRequest({
      url: urlH,
      loader: "Cargando cabecera de toma de inventario...",
    });
    if (respH.HasError || !respH.result) return;
    // Detalle paginado - usar filtro actual si existe
    await handleTomaLoadDetalles(folio, 1);
    setTomaDetallePage(1);
    setTomaHeader((prev) => {
      const result = { ...prev };
      if (respH.result) {
        result.folioinventario =
          respH.result.folioinventario ?? respH.result.iFolioInventario ?? 0;
        result.usuarioresponsable = (
          respH.result.usuarioresponsable ??
          respH.result.sUsuarioResponsable ??
          ""
        ).trim();
        result.statusinventario = (
          respH.result.statusinventario ??
          respH.result.sStatusInventario ??
          "AB"
        ).trim();
        result.almacenexhibidor = (
          respH.result.almacenexhibidor ??
          respH.result.sAlmacenExhibidor ??
          ""
        ).trim();
        result.tipoinventario = (
          respH.result.tipoinventario ??
          respH.result.sTipoInventario ??
          "GENERAL"
        ).trim();
        result.totalzonas =
          respH.result.totalzonas ?? respH.result.iTotalZonas ?? 0;
        result.totalarticulos =
          respH.result.totalarticulos ?? respH.result.iTotalArticulos ?? 0;
        result.totalinventariados =
          respH.result.totalinventariados ??
          respH.result.iTotalInventariados ??
          0;
        result.totalfaltantes =
          respH.result.totalfaltantes ?? respH.result.iTotalFaltantes ?? 0;
        result.articuloscondiferencias =
          respH.result.articuloscondiferencias ??
          respH.result.iArticulosConDiferencias ??
          0;
      }
      
        return result;
    });
  };

  // Cargar detalles con paginación
  const handleTomaLoadDetalles = async (
    folio,
    page = 1,
    pageSize,
    filterText = ""
  ) => {
    if (!folio || folio <= 0) return;

    // Usar el valor del estado si no se proporciona
    const effectivePageSize = pageSize ?? tomaDetallePageSize;

    let urlD = apiTomaInventarioGetDetallePaginados.replace(
      "{folioinventario}",
      folio
    );

    // Agregar parámetros
    const params = new URLSearchParams({
      page: String(page),
      pageSize: String(effectivePageSize),
    });

    if (filterText && filterText.trim()) {
      params.append("filter", filterText.trim());
    }

    urlD = urlD + "?" + params.toString();

    const respD = await GetRequest({
      url: urlD,
      loader: `Cargando página ${page}...`,
    });

    if (respD.hasError) return;

    if (respD?.result) {
      setTomaDetalle(respD.result.items || []);
      setTomaDetalleTotalCount(respD.result.total || 0);
      setTomaDetalleTotalPages(respD.result.totalPages || 0);
      setTomaDetallePage(page);
    } else {
      setTomaDetalle([]);
    }
  };

  // Cambiar página
  const handleTomaChangePage = async (newPage) => {
    const folio = tomaHeader?.folioinventario;

    // Validar que la página solicitada sea válida
    if (!folio) return;
    if (newPage < 1) return;
    if (newPage > tomaDetalleTotalPages) return;

    await handleTomaLoadDetalles(
      folio,
      newPage,
      tomaDetallePageSize,
      tomaDetalleFilter
    );
  };

  // Cambiar tamaño de página
  const handleTomaChangePageSize = async (newPageSize, currentPage = 1) => {
    const folio = tomaHeader?.folioinventario;
    if (folio) {
      setTomaDetallePageSize(newPageSize);
      // Mantener página actual para dar sensación de avance
      await handleTomaLoadDetalles(
        folio,
        currentPage,
        newPageSize,
        tomaDetalleFilter
      );
    }
  };

  // Filtrar detalles por descripción
  const handleTomaFilter = async (filterText) => {
    const folio = tomaHeader?.folioinventario;
    if (folio) {
      setTomaDetalleFilter(filterText);
      await handleTomaLoadDetalles(folio, 1, tomaDetallePageSize, filterText);
    }
  };

  const handleTomaCrearFolio = async () => {
    if (!tomaHeader.usuarioresponsable?.trim()) {
      handleOpenAlert("Falta Usuario Responsable");
      return;
    }

    if (!tomaHeader.almacenexhibidor?.trim()) {
      handleOpenAlert("Falta Almacén/Exhibidor");
      return;
    }

    const body = {
      usuarioresponsable: tomaHeader.usuarioresponsable.trim(),
      almacenexhibidor: tomaHeader.almacenexhibidor.trim(),
      statusinventario: "AB",
      tipoinventario: tomaHeader.tipoinventario || "GENERAL",
    };

    const resp = await PostRequest({
      url: apiTomaInventarioCrearFolio,
      body,
      loader: "Iniciando folio de toma de inventario...",
    });

    if (resp.HasError || !resp.result) {
      return;
    }

    setTomaHeader((prev) => ({
      ...prev,
      ...resp.result,
      tipoInventario: prev.tipoInventario || "GENERAL",
    }));

    const folioCreado =
      resp.result.folioinventario ?? resp.result.FolioInventario;
    const tipoInventario = (tomaHeader.tipoinventario || "GENERAL")
      .trim()
      .toUpperCase();

    if (tipoInventario === "GENERAL") {
      const url = apiTomaInventarioCargarGeneral.replace(
        "{folioinventario}",
        folioCreado
      );

      const cargaResp = await PostRequest({
        url,
        body: { almacenExhibidor: tomaHeader.almacenexhibidor.trim() },
        loader: "Cargando artículos del inventario GENERAL...",
      });

      if (cargaResp.HasError) {
        handleOpenAlert("Falló la carga GENERAL" + cargaResp , "error");
        return;
      }

      await handleTomaLoadAll(folioCreado);
    } else {
      setTomaDetalle([]);
    }

    handleOpenAlert(`Folio creado: ${folioCreado}`, "OK");
    return resp.result;
  };

  const handleTomaGuardarHeader = async () => {
    if (!tomaHeader.folioinventario || tomaHeader.folioinventario <= 0) {
      handleOpenAlert("Primero inicia un folio");
      return;
    }

    const body = {
      ...tomaHeader,
      pc: parametrosCajaForm.caja?.trim().toUpperCase(),
      usuario,
    };

    const resp = await PostRequest({
      url: apiTomaInventarioSaveHeader,
      body,
      loader: "Guardando cabecera de inventario...",
    });

    if (resp.HasError) return;

    handleOpenAlert("Cabecera guardada", "OK");
  };

  const handleTomaCargarArticulos = async () => {
    if (!tomaHeader.folioinventario || tomaHeader.folioinventario <= 0) {
      handleOpenAlert("Primero inicia un folio");
      return;
    }

    if (!tomaHeader.almacenexhibidor?.trim()) {
      handleOpenAlert("Selecciona Almacén/Exhibidor");
      return;
    }

    if (tomaHeader.statusinventario !== "AB") {
      handleOpenAlert("Inventario no editable");
      return;
    }

    // General => backend carga todos activos (con o sin existencias)
    if ((tomaHeader.tipoinventario || "GENERAL") === "GENERAL") {
      let url = apiTomaInventarioCargarGeneral.replace(
        "{folioinventario}",
        tomaHeader.folioinventario
      );
      const resp = await PostRequest({
        url,
        body: { almacenExhibidor: tomaHeader.almacenexhibidor.trim() },
        loader: "Cargando inventario GENERAL...",
      });

      if (resp.HasError) return;

      await handleTomaLoadAll(tomaHeader.folioinventario);
      handleOpenAlert("Inventario general cargado", "OK");
      return;
    }

    // Selectivo => abre modal buscador (para seleccionar artículos)
    setStatusModalBuscadorArticulosTomaInventario(true);
  };

  // Abrir modal de búsqueda para inventario selectivo
  const handleOpenBuscarArticuloDescripcionTomaInventario = async () => {
    setStatusModalBuscadorArticulosTomaInventario(true);
  };

  const handleTomaBuscarArticulos = async (q) => {
    const filtro = (q ?? tomaBuscadorQ ?? "").trim();
    if (filtro.length < 2) {
      setTomaArticulosFound([]);
      return;
    }

    const url = apiBuscarArticulosInventario.replace(
      "{q}",
      encodeURIComponent(filtro)
    );
    const resp = await GetRequest({
      url,
      loader: "Buscando artículos...",
    });

    if (resp.HasError) {
      setTomaArticulosFound([]);
      return;
    }

    setTomaArticulosFound(resp.result || []);
  };

  const handleTomaAgregarArticuloSelectivo = async (claveArticulo) => {
    if (!tomaHeader.folioinventario || tomaHeader.folioinventario <= 0) return;

    // Trim para quitar padding
    const clave = claveArticulo?.trim();
    if (!clave) return;

    let url = apiTomaInventarioAgregarArticulo.replace(
      "{folio}",
      tomaHeader.folioinventario
    );
    const body = {
      folioinventario: tomaHeader.folioinventario,
      almacenexhibidor: tomaHeader.almacenexhibidor.trim(),
      clavearticulo: clave,
      usuarioresponsable: usuario,
      pc: parametrosCajaForm.caja?.trim()?.toUpperCase(),
    };

    const resp = await PostRequest({
      url,
      body,
      loader: "Agregando artículo (con todas sus medidas)...",
    });
    if (resp.HasError) return;

    // Cerrar modal y recargar datos
    setStatusModalBuscadorArticulosTomaInventario(false);
    await handleTomaLoadAll(tomaHeader.folioinventario);
    handleOpenAlert("Artículo agregado al inventario selectivo", "OK");
  };

  const handleTomaGuardarDetalle = async () => {
    if (!tomaHeader.folioinventario || tomaHeader.folioinventario <= 0) return;

    let url = apiTomaInventarioSaveDetalle.replace(
      "{folio}",
      tomaHeader.folioinventario
    );
    const resp = await PostRequest({
      url,
      body: tomaDetalle,
      loader: "Guardando detalle de toma...",
    });

    if (resp.HasError) return;

    handleOpenAlert("Detalle guardado", "OK");
  };

  const handleTomaActualizarConteoAFijar = async (
    folio,
    claveArticulo,
    medida,
    conteoAFijar
  ) => {
    const url = apiTomaInventarioActualizarConteoAFijar.replace(
      "{folioinventario}",
      folio
    );

    const body = {
      claveArticulo: claveArticulo,
      medida: medida,
      conteoAFijar: conteoAFijar,
    };

    const resp = await PutRequest({
      url,
      body,
      loader: "Actualizando conteo...",
    });

    if (resp.HasError) {
      handleOpenAlert("Error al actualizar conteo a fijar", "ERROR");
      return false;
    }

    return true;
  };

  const handleTomaEliminarArticulo = async (folio, claveArticulo) => {
    if (!folio || folio <= 0) {
      handleOpenAlert("Folio inválido");
      return;
    }
    if (!claveArticulo) {
      handleOpenAlert("Artículo no seleccionado");
      return;
    }

    const body = { claveArticulo };

    const resp = await PostRequest({
      url: apiTomaInventarioEliminarArticulo.replace(
        "{folioinventario}",
        folio
      ),
      body,
      loader: "Eliminando artículo...",
    });

    if (resp.HasError) {
      handleOpenAlert(
        "Error al eliminar artículo: " + (resp.message || ""),
        "ERROR"
      );
      return;
    }

    handleOpenAlert("Artículo eliminado", "OK");
  };

  const handleTomaEliminarTodo = async (folio) => {
    if (!folio || folio <= 0) {
      handleOpenAlert("Folio inválido");
      return;
    }

    const resp = await PostRequest({
      url: apiTomaInventarioEliminarTodo.replace("{folioinventario}", folio),
      body: {},
      loader: "Eliminando todos los artículos...",
    });

    if (resp.HasError) {
      handleOpenAlert(
        "Error al eliminar artículos: " + (resp.message || ""),
        "ERROR"
      );
      return;
    }

    handleOpenAlert("Todos los artículos eliminados", "OK");
  };

  const handleTomaImportarConteos = async ({
    ConteoNumero = 1,
  } = {}) => {
    if (!tomaHeader.folioinventario || tomaHeader.folioinventario <= 0) {
      handleOpenAlert("Primero inicia un folio");
      return;
    }

    if (!tomaHeader.almacenexhibidor?.trim()) {
      handleOpenAlert("Selecciona Almacén/Exhibidor");
      return;
    }

    const body = {
      FolioInventario: tomaHeader.folioinventario,
      AlmacenExhibidor: tomaHeader.almacenexhibidor.trim(),
      ConteoNumero,
      usuario,
      pc: parametrosCajaForm.caja?.trim()?.toUpperCase(),
    };

    let url = apiTomaInventarioImportarConteos.replace(
      "{folioinventario}",
      tomaHeader.folioinventario
    );

    const resp = await PostRequest({
      url,
      body,
      loader: `Importando Conteo ${ConteoNumero}...`,
    });

    if (resp.hasError) {
      handleOpenAlert(`Error al importar Conteo ${ConteoNumero}: ${resp.Message || resp.message || "Error desconocido"}`, "warning");
      return;
    }

    // Forzar recarga sin importar si el backend reportó resultado
    await handleTomaLoadAll(tomaHeader.folioinventario);
    handleOpenAlert(`Conteo ${ConteoNumero} importado`, "OK");
  };

  const handleTomaValidarZonas = async () => {
    if (!tomaHeader.folioinventario || tomaHeader.folioinventario <= 0) return;

    let url = apiTomaInventarioValidarZonas.replace(
      "{folio}",
      tomaHeader.folioinventario
    );
    const resp = await GetRequest({
      url,
      loader: "Validando zonas (Conteo 1 vs Conteo 2)...",
    });

    if (resp.HasError) return;

    const diffs = resp.result || [];
    setTomaZonasDiff(diffs);
    setOpenModalTomaZonasDiff(true);

    const hayDif = diffs.some((x) => x.Diferentes);
    handleOpenAlert(
      hayDif
        ? "Hay zonas con diferencias: requiere Conteo 3"
        : "Zonas consistentes",
      hayDif ? "Alert" : "OK"
    );
  };

  const handleTomaFijarConteoPorRegla = async () => {
    if (!tomaHeader.folioinventario || tomaHeader.folioinventario <= 0) return;

    let url = apiTomaInventarioFijarConteo.replace(
      "{folio}",
      tomaHeader.folioinventario
    );
    const resp = await PostRequest({
      url,
      body: { usuario, pc: parametrosCajaForm.caja?.trim()?.toUpperCase() },
      loader: "Fijando conteo a aplicar por regla...",
    });

    if (resp.HasError) return;

    await handleTomaLoadAll(tomaHeader.folioinventario);
    handleOpenAlert("Conteo a aplicar fijado", "OK");
  };

  const handleTomaFijarTodoConteo = async (conteoNumero) => {
    const folio = tomaHeader?.folioinventario;
    if (!folio || folio <= 0) {
      handleOpenAlert("Primero inicia un folio");
      return;
    }

    let url = apiTomaInventarioFijarTodoConteo
      .replace("{folioinventario}", folio)
      .replace("{conteoNumero}", conteoNumero);

    const resp = await PostRequest({
      url,
      loader: `Fijando todo a conteo ${conteoNumero}...`,
    });

    if (resp.HasError) return;

    await handleTomaLoadAll(folio);
    handleOpenAlert(`Todos fijados a C${conteoNumero}`, "OK");
  };

  const handleTomaReiniciarConteos = async () => {
    const folio = tomaHeader?.folioinventario;
    if (!folio || folio <= 0) {
      handleOpenAlert("Primero inicia un folio");
      return;
    }

    let url = apiTomaInventarioReiniciarConteos.replace(
      "{folioinventario}",
      folio
    );

    const resp = await PostRequest({
      url,
      loader: "Reiniciando conteos...",
    });

    if (resp.hasError) {
      handleOpenAlert(resp.message || "Error al reiniciar conteos", "warning");
      return;
    }
  };

  const handleTomaReiniciarConteoArticulo = async (claveArticulo) => {
    const folio = tomaHeader?.folioinventario;
    if (!folio || folio <= 0) {
      handleOpenAlert("Primero inicia un folio");
      return;
    }
    if (!claveArticulo) return;

    let url = apiTomaInventarioReiniciarConteoArticulo.replace(
      "{folioinventario}",
      folio
    );

    const resp = await PostRequest({
      url,
      body: { claveArticulo: claveArticulo.trim() },
      loader: "Reiniciando conteo del artículo...",
    });

    if (resp.hasError) {
      handleOpenAlert(resp.message || "Error al reiniciar conteo del artículo", "warning");
      return;
    }

    await handleTomaLoadAll(folio);
  };

  const handleTomaEditarConteo3 = async (claveArticulo, medida, conteo3) => {
    const folio = tomaHeader?.folioinventario;
    if (!folio || folio <= 0) {
      handleOpenAlert("Primero inicia un folio");
      return;
    }
    if (!claveArticulo) return;

    let url = apiTomaInventarioEditarConteo3.replace(
      "{folioinventario}",
      folio
    );

    const resp = await PostRequest({
      url,
      body: { claveArticulo: claveArticulo.trim(), medida, conteo3 },
      loader: "Editando conteo 3...",
    });

    if (resp.hasError) {
      handleOpenAlert(resp.message || "Error al editar conteo 3", "warning");
      return;
    }

    await handleTomaActualizarConteoAFijar(folio, claveArticulo.trim(), medida, 3);

    await handleTomaLoadAll(folio);
  };

  const handleTomaEliminarConteosEscaneo = async () => {
    const folio = tomaHeader?.folioinventario;
    if (!folio || folio <= 0) {
      handleOpenAlert("Primero inicia un folio");
      return;
    }

    let url = apiTomaInventarioEliminarConteosEscaneo.replace(
      "{folioinventario}",
      folio
    );

    const resp = await PostRequest({
      url,
      loader: "Eliminando ConteosEscaneo...",
    });

    if (resp.hasError) {
      handleOpenAlert(resp.message || "Error al eliminar ConteosEscaneo", "warning");
      return;
    }

    handleOpenAlert(resp.message || "ConteosEscaneo eliminados correctamente");
  };

  const handleTomaImportarConteosAConteosEscaneo = async () => {
    const folio = tomaHeader?.folioinventario;
    if (!folio || folio <= 0) {
      handleOpenAlert("Primero inicia un folio");
      return;
    }

    let url = apiTomaInventarioImportarConteosAConteosEscaneo.replace(
      "{folioinventario}",
      folio
    );

    const resp = await PostRequest({
      url,
      loader: "Importando conteos remotos a escaneos...",
    });

    if (resp.hasError) {
      handleOpenAlert(resp.message || "Error al importar conteos a escaneos", "warning");
      return;
    }

    handleOpenAlert(`Importados ${resp.result || 0} conteos a escaneos`, "OK");
  };

  const handleTomaCerrarInventario = async (folioInventario) => {
    const folio = folioInventario || tomaHeader.folioinventario;
    if (!folio || folio <= 0) return false;

    if (tomaHeader.statusinventario !== "AB") {
      handleOpenAlert("El inventario ya no está activo");
      return false;
    }

    let url = apiTomaInventarioCerrar.replace(
      "{folioinventario}",
      folio
    );
    const resp = await PostRequest({
      url,
      body: { usuario, pc: parametrosCajaForm.caja?.trim()?.toUpperCase() },
      loader: "Cerrando inventario...",
    });

    if (resp.HasError) return false;

    await handleTomaLoadAll(folio);
    handleOpenAlert("Inventario cerrado", "OK");
    return true;
  };

  const handleTomaAplicarInventario = async (
    folioInventario,
    permitirDespuesDeCerrar = false
  ) => {
    const folio = folioInventario || tomaHeader.folioinventario;
    if (!folio || folio <= 0) return false;

    if (tomaHeader.statusinventario !== "CE" && !permitirDespuesDeCerrar) {
      handleOpenAlert("Primero debes cerrar el inventario");
      return false;
    }
    let url = apiTomaInventarioAplicar.replace(
      "{folioinventario}",
      folio
    );
    
    const resp = await PostRequest({
      url,
      body: { usuario, pc: parametrosCajaForm.caja?.trim()?.toUpperCase() },
      loader: "Aplicando inventario al almacén/exhibidor...",
    });
    if (resp.HasError) return false;

    await handleTomaLoadAll(folio);
    handleOpenAlert("Inventario aplicado", "OK");
    return true;
  };

  const handleTomaCancelarInventario = async (folioInventario) => {
    const folio = folioInventario || tomaHeader?.folioinventario;
    if (!folio || folio <= 0) return false;

    if (!["AB", "CE"].includes(tomaHeader?.statusinventario)) {
      handleOpenAlert("Solo puedes cancelar una toma abierta o cerrada pendiente de aplicar");
      return false;
    }

    let url = apiTomaInventarioCancelar.replace(
      "{folioinventario}",
      folio
    );
    const resp = await PostRequest({
      url,
      body: { usuario, pc: parametrosCajaForm.caja?.trim()?.toUpperCase() },
      loader: "Cancelando toma de inventario...",
    });

    if (resp.HasError) return false;

    handleTomaReset();
    setTomaDetallePage(1);
    setTomaDetalleTotalCount(0);
    setTomaDetalleTotalPages(0);
    setTomaDetalleFilter("");
    handleOpenAlert("Toma de inventario cancelada. Ya puedes iniciar otra toma.", "OK");
    return true;
  };

  const handleTomaImprimirPdf = async (folio) => {
    const folioReal = folio || tomaHeader?.folioinventario;
    if (!folioReal || folioReal <= 0) return;

    const urlSend = apiTomaInventarioPdf.replace("{folioinventario}", folioReal);
    setStatusWaiting(true);
    await GetFileRequest({ url: urlSend, openInNewTab: true });
    setStatusWaiting(false);
  };

  const handleArticuloSeleccionado = async (articulo) => {
    if (!articulo || !articulo.clavearticulo) return;
    // Trim para quitar padding NCHAR
    const clave = articulo.clavearticulo.trim();
    await handleTomaAgregarArticuloSelectivo(clave);
  };

  const handleTomaBuscarYAgregarPorCodigoBarras = async (codigobarras) => {
    if (!codigobarras || !tomaHeader?.folioinventario) return { HasError: true, Message: "Folio de inventario no disponible" };

    const response = await GetRequest({
      url: apiBuscarArticuloPorCodigoBarras.replace("{codigobarras}", codigobarras),
      alert: "Buscando artículo por código de barras",
    });

    if (response.HasError || !response?.result?.clavearticulo) {
      handleOpenAlert("Artículo no encontrado para el código de barras ingresado");
      return { HasError: true, Message: "Artículo no encontrado" };
    }

    const clave = response.result.clavearticulo.trim();
    const addResult = await handleTomaAgregarArticuloSelectivo(clave);

    if (addResult?.HasError) {
      handleOpenAlert(addResult.Message || "Error al agregar artículo");
      return addResult;
    }

    return { HasError: false, Message: "Artículo agregado" };
  };

  const handleAbrirFirmaTraslados = () => {
    setOpenModalFirmaTraslados(true);
  };

  const handleCerrarFirmaTraslados = () => {
    setOpenModalFirmaTraslados(false);
  };

  const handleAbrirValidarAccesoTraslados = () => {
    setOpenModalValidarAcceso(true);
  };

  const handleCerrarValidarAccesoTraslados = () => {
    setOpenModalValidarAcceso(false);
  };

  const handleEjecutarTrasladoValidado = (status) => {
    if (!status) return;
    handleAplicarTrasladoPC(null, parametrosCajaForm.caja);
  };

  const handleDarIngresoRapido = async (clavearticulo, medida, almacenexhibidor, pc) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") {
      return;
    }

    if (clavearticulo === null || clavearticulo === undefined) {
      handleOpenAlert(`Artículo no especificado`);
      return;
    }

    if (medida === null || medida === undefined) {
      handleOpenAlert(`Medida no especificada`);
      return;
    }

    if (almacenexhibidor === null || almacenexhibidor === undefined) {
      handleOpenAlert(`Almacén no especificado`);
      return;
    }

    if (pc === null || PieChart === undefined) {
      handleOpenAlert(`Caja/Pc no especificada`);
      return;
    }

    const url = apiIngresoRapido
      .replace("{clavearticulo}", clavearticulo)
      .replace("{medida}", medida)
      .replace("{almacenexhibidor}", almacenexhibidor.trim().toUpperCase())
      .replace("{pc}", pc.trim().toUpperCase());

    const response = await PostRequest({
      url,
      loader: "Realizando ingreso a inventario rápido...",
    });

    if (response.HasError) return;

    if (response.result == null) return;

    handleOpenAlert(`Ingreso rápido realizado: ${response.result}`, "OK");
    return response.result;
  };

  const handleSincronizarExistenciasEntradas = async () => {
    // Rev 6: primero se fina el buffer en las tablas y luego se sincroniza.
    if (titleActionSave === "GUARDAR") {
      if (!(await handleFlushEntradaRedis())) return;
    }
    const url = apiSincronizarExistenciasEntradas;

    const response = await GetRequest({
      url,
      loader: "Sincronizando existencias de entradas...",
    });

    if (response.HasError) return;

    handleOpenAlert(`Sincronización de entradas completada`, "OK");
    return response.result;
  };

  const handleSincronizarExistenciasFiltradas = async (lista, almacen) => {
    if (isNullOrEmpty(almacen)) {
      handleOpenAlert("Debe seleccionar un almacén para sincronizar");
      return;
    }

    if (!lista || lista.length === 0) {
      handleOpenAlert("No hay artículos en la lista para sincronizar");
      return;
    }

    const url = apiSincronizarExistenciasFiltro;
    const body = {
      lista: lista,
      almacen: almacen.trim().toUpperCase(),
    };

    const response = await PostRequest({
      url,
      body,
      loader: "Sincronizando existencias filtradas...",
    });

    if (response.HasError) return;

    handleOpenAlert(`Sincronización finalizada correctamente`, "OK");
    return response.result;
  };

  const handleSincronizarExistenciaArticulo = async (clave, medida, almacen) => {
    if (isNullOrEmpty(clave) || isNullOrEmpty(almacen)) {
      return;
    }

    const url = apiSincronizarExistenciaArticulo
      .replace("{clavearticulo}", clave.trim().toUpperCase())
      .replace("{medida}", medida)
      .replace("{almacen}", almacen.trim().toUpperCase());

    const response = await GetRequest({
      url,
      loader: `Sincronizando existencia de ${clave} medida ${medida} en ${almacen}...`,
    });

    if (response.HasError) return;

    return response.result;
  };

  // ─── Rev 3 (23/09/2026): catálogo de códigos en Redis + buffer temporal ────
  // Todo via RequestContext (porta el JWE del tenant, nunca fetch directo).
  // Entradas: catálogo sin existencias. Salidas: existencia fresca desde SQL
  // en cada captura (las existencias son dinámicas: ventas/traslados de otras
  // máquinas) y renovación del caché Redis en paralelo en el backend.
  const normalizarCodigoCbarras = (valor) => String(valor ?? "").trim().toUpperCase();
  const normalizarCodigoCbarrasAlterno = (valor) => {
    const sinA = normalizarCodigoCbarras(valor).replace(/^A+/, "");
    const sinCeros = sinA.replace(/^0+/, "");
    return sinCeros || sinA || "0";
  };

  const catalogoCbarrasRef = useRef(new Map());
  const cargaCatalogoCbarrasRef = useRef(null);
  const [catalogoCbarrasInfo, setCatalogoCbarrasInfo] = useState({ total: 0, cargados: 0, listo: false });

  const resolverArticuloCbarrasLocal = (codigo) => {
    const mapa = catalogoCbarrasRef.current;
    if (!mapa || mapa.size === 0) return null;
    return mapa.get(normalizarCodigoCbarras(codigo)) || mapa.get(normalizarCodigoCbarrasAlterno(codigo)) || null;
  };

  const agregarArticuloCbarrasLocal = (articulo) => {
    if (!articulo) return null;
    const cb = String(articulo.codigobarras || articulo.codigoBarras || articulo.sCodigoBarras || "").trim();
    if (!cb) return null;
    const normalizado = {
      clavearticulo: String(articulo.clavearticulo || articulo.sClaveArticulo || "").trim(),
      descripcion: String(articulo.descripcion || articulo.sDescripcion || "").trim(),
      medida: Number(articulo.medida || articulo.dMedida || 0),
      factor: Number(articulo.factor || articulo.dFactor || 1) || 1,
      pmvb: Number(articulo.pmvb || articulo.dPMVB || 0),
      costoventa: Number(articulo.costoventa || articulo.dCostoVenta || articulo.preciodefinitivo || 0),
      codigobarras: cb,
    };
    if (!normalizado.clavearticulo) return null;
    const mapa = catalogoCbarrasRef.current;
    const n1 = normalizarCodigoCbarras(cb);
    if (n1 && !mapa.has(n1)) mapa.set(n1, normalizado);
    const n2 = normalizarCodigoCbarrasAlterno(cb);
    if (n2 && !mapa.has(n2)) mapa.set(n2, normalizado);
    return normalizado;
  };

  // Carga oculta por páginas: llena el Map local y siembra Redis en backend.
  const handleCargarCatalogoCbarras = async (onProgress) => {
    if (cargaCatalogoCbarrasRef.current) return cargaCatalogoCbarrasRef.current;
    if (catalogoCbarrasRef.current.size > 0 && catalogoCbarrasInfo.listo) {
      return catalogoCbarrasRef.current.size;
    }
    const tarea = (async () => {
      const pageSize = 2000;
      let page = 1;
      let total = Infinity;
      let cargados = 0;
      for (;;) {
        const url = apiEntradasCatalogoCbarras
          .replace("{page}", page)
          .replace("{pageSize}", pageSize);
        const response = await GetRequest({ url });
        if (response.hasError || response.HasError || !response.result) break;
        const items = response.result.items || response.result.lstItems || [];
        const t = response.result.total ?? response.result.iTotal;
        if (Number.isFinite(t)) total = t;
        for (const item of items) agregarArticuloCbarrasLocal(item);
        cargados += items.length;
        setCatalogoCbarrasInfo({ total: total === Infinity ? cargados : total, cargados, listo: false });
        try { onProgress?.({ page, cargados, total }); } catch {}
        if (items.length < pageSize || page >= 200) break;
        page += 1;
      }
      setCatalogoCbarrasInfo((prev) => ({ total: prev.total || cargados, cargados, listo: true }));
      return catalogoCbarrasRef.current.size;
    })();
    cargaCatalogoCbarrasRef.current = tarea;
    try {
      return await tarea;
    } finally {
      cargaCatalogoCbarrasRef.current = null;
    }
  };

  // Read-through para ENTRADAS (sin existencias): local -> endpoint Redis/SQL.
  const handleResolverCodigoEntradas = async (codigo) => {
    const local = resolverArticuloCbarrasLocal(codigo);
    if (local) return local;
    const limpio = String(codigo || "").trim();
    if (!limpio) return null;
    const url = apiEntradasResolverCodigo.replace("{codigo}", encodeURIComponent(limpio));
    const response = await GetRequest({ url });
    if (response.hasError || response.HasError || !response.result) {
      handleOpenAlert(response.message || `El código ${limpio} no existe en el catálogo`);
      return null;
    }
    return agregarArticuloCbarrasLocal(response.result);
  };

  // Read-through para SALIDAS con existencia FRESCA desde SQL.
  const handleResolverCodigoSalidas = async (codigo, almacen) => {
    const limpio = String(codigo || "").trim();
    const alm = String(almacen || "").trim();
    if (!limpio || !alm) return null;
    const url = apiSalidasResolverCodigo
      .replace("{codigo}", encodeURIComponent(limpio))
      .replace("{almacen}", encodeURIComponent(alm));
    const response = await GetRequest({ url });
    if (response.hasError || response.HasError || !response.result) {
      handleOpenAlert(response.message || `El código ${limpio} no existe o no tiene existencia en ${alm}`);
      return null;
    }
    const r = response.result;
    const art = {
      clavearticulo: String(r.clavearticulo || "").trim(),
      descripcion: String(r.descripcion || "").trim(),
      medida: Number(r.medida || 0),
      codigobarras: String(r.codigobarras || limpio).trim(),
      existencia: Number(r.existencia || 0),
    };
    const local = resolverArticuloCbarrasLocal(limpio);
    if (local) {
      art.factor = local.factor;
      art.pmvb = local.pmvb;
      art.costoventa = local.costoventa;
      if (!art.descripcion) art.descripcion = local.descripcion;
    } else {
      art.factor = 1; art.pmvb = 0; art.costoventa = 0;
    }
    return art;
  };

  const mezclarPartidaCapturada = (setLista, partida) => {
    setLista((prev) => {
      const base = Array.isArray(prev) ? prev : [];
      const index = base.findIndex((item) => claveMedidaAlmacenIguales(item, partida));
      if (index >= 0) {
        const updated = [...base];
        const suma = (Number(updated[index].cantidadarticulo) || 0) + (Number(partida.cantidadarticulo) || 0);
        updated[index] = { ...updated[index], cantidadarticulo: suma };
        return updated;
      }
      return [...base, { ...partida, id: nuevoIdLocal(base) }];
    });
  };

  // Captura de ENTRADA en buffer Redis (sin localStorage en el camino).
  const handleCapturarEntradaRedis = async (articulo, cantidad = 1, pcOverride) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return null;
    if (!articulo?.clavearticulo) {
      handleOpenAlert(`Artículo no existente`);
      return null;
    }
    if (isNullOrEmpty(folioEntrada)) {
      handleOpenAlert(`Es necesario cargar una entrada`);
      return null;
    }
    if (isNullOrEmpty(String(conceptoEntrada || "").trim())) {
      handleOpenAlert(`Es necesario cargar el concepto para continuar`);
      return null;
    }
    if (isNullOrEmpty(String(almacenExhibidor || "").trim())) {
      handleOpenAlert(`Es necesario cargar el almacén/exhibidor para continuar`);
      return null;
    }
    const statusActual = (statusEntrada || "").trim().toUpperCase();
    if (statusActual === "TR" || statusActual === "CA") {
      handleOpenAlert(statusActual === "CA"
        ? `Entrada cancelada, no se pueden registrar más articulos`
        : `Entrada ya terminada, no se pueden registrar más articulos`);
      return null;
    }
    const pcActual = String(pcOverride || parametrosCajaForm.caja || "").trim().toUpperCase();
    const qty = Number(cantidad) > 0 ? Number(cantidad) : 1;
    const response = await PostRequest({
      url: apiEntradasCapturar,
      body: {
        codigobarras: String(articulo.codigobarras || "").trim(),
        clavearticulo: articulo.clavearticulo,
        descripcion: articulo.descripcion || "",
        medida: articulo.medida || 0,
        factor: articulo.factor || 1,
        pmvb: articulo.pmvb || 0,
        costoventa: articulo.costoventa || 0,
        cantidadacumulada: qty,
        captureindex: 0,
        folio: folioEntrada,
        almacenexhibidor: almacenExhibidor,
        pc: pcActual,
        usuario: usuario,
      },
    });
    if (response.hasError || response.HasError || !response.result?.registrado) {
      handleOpenAlert(response.message || "Error al capturar artículo en entrada");
      return null;
    }
    const p = response.result.partida;
    mezclarPartidaCapturada(setListaEntradas, {
      clavearticulo: p.clavearticulo,
      descripcion: response.result.descripcion || articulo.descripcion || "",
      medida: p.medida,
      cantidadarticulo: p.cantidad,
      factor: p.factor,
      folioentradasalida: folioEntrada,
      conceptoentradasalida: conceptoEntrada,
      pmvb: p.pmvb,
      costoventa: p.costoventa,
      almacenexhibidor: almacenExhibidor,
      usuario: usuario,
      pc: pcActual,
      statusentradasalida: "PE",
    });
    setTitleActionSave("GUARDAR");
    return { clavearticulo: p.clavearticulo, medida: p.medida, almacenexhibidor: almacenExhibidor };
  };

  // Captura de SALIDA en buffer Redis con validación de existencia en SQL.
  const handleCapturarSalidaRedis = async (articulo, cantidad = 1, pcOverride) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return null;
    if (!articulo?.clavearticulo) {
      handleOpenAlert(`Artículo no existente`);
      return null;
    }
    if (isNullOrEmpty(folioSalida)) {
      handleOpenAlert(`Es necesario cargar una salida`);
      return null;
    }
    if (isNullOrEmpty(conceptoSalida)) {
      handleOpenAlert(`Es necesario cargar el concepto para continuar`);
      return null;
    }
    if (isNullOrEmpty(String(almacenExhibidorSalida || "").trim())) {
      handleOpenAlert(`Es necesario cargar el almacén/exhibidor para continuar`);
      return null;
    }
    const statusActual = (statusSalida || "").trim().toUpperCase();
    if (statusActual === "TR" || statusActual === "CA") {
      handleOpenAlert(statusActual === "CA"
        ? `Salida cancelada, no se pueden registrar más articulos`
        : `Salida ya terminada, no se pueden registrar más articulos`);
      return null;
    }
    const pcActual = String(pcOverride || parametrosCajaForm.caja || "").trim().toUpperCase();
    const qty = Number(cantidad) > 0 ? Number(cantidad) : 1;
    const response = await PostRequest({
      url: apiSalidasCapturar,
      body: {
        codigobarras: String(articulo.codigobarras || articulo.codigoBarras || articulo.clavearticulo || "").trim(),
        clavearticulo: articulo.clavearticulo || "",
        descripcion: articulo.descripcion || "",
        medida: articulo.medida || 0,
        factor: articulo.factor || 1,
        pmvb: articulo.pmvb || 0,
        costoventa: articulo.costoventa || 0,
        cantidadacumulada: qty,
        captureindex: 0,
        folio: folioSalida,
        almacenexhibidor: almacenExhibidorSalida,
        pc: pcActual,
        usuario: usuario,
      },
    });
    if (response.hasError || response.HasError || !response.result) {
      handleOpenAlert(response.message || "Error al capturar artículo en salida");
      return null;
    }
    const captura = response.result;
    if (!captura.registrado) {
      const sinStockItem = {
        clavearticulo: captura.clavearticulo || "",
        descripcion: captura.descripcion || "",
        medida: captura.medida || "",
        existencia: captura.existencia || 0,
        solicitado: captura.solicitado || 0,
        acumulado: captura.acumulado || 0,
      };
      try { SalidasLocalService.agregarSinExistencias(sinStockItem); } catch {}
      handleOpenAlert(`Sin existencia en ${almacenExhibidorSalida}. Solicitado: ${captura.solicitado || 0}, Existencia: ${captura.existencia || 0}`);
      return { registrado: false, ...sinStockItem };
    }
    const partidaRaw = captura.partida;
    if (partidaRaw) {
      mezclarPartidaCapturada(setListaSalidas, {
        ...partidaRaw,
        codigobarras: partidaRaw.codigobarras || String(articulo.codigobarras || "").trim(),
        descripcion: partidaRaw.descripcion || captura.descripcion || "",
        cantidadarticulo: partidaRaw.cantidad,
      });
    }
    setTitleActionSave("GUARDAR");
    return captura;
  };

  // Finado Redis -> SQL (guardar/imprimir/buscar/aplicar/salir + autofinado
  // periódico). Rev 5: se mandan las partidas en pantalla ADEMÁS del buffer,
  // para que el finado funcione aunque Redis esté caído o el backend aún no
  // tenga el flujo Redis. El backend fusiona ambas fuentes y agrupa por
  // clave|medida|almacén; el recorte del buffer es exacto (no duplica).
  const mapearItemsFinado = (lista, almacenDefecto) =>
    (Array.isArray(lista) ? lista : []).map((i) => ({
      clavearticulo: i.clavearticulo || i.sClaveArticulo,
      descripcion: i.descripcion || i.sDescripcion || "",
      medida: i.medida ?? i.dMedida,
      cantidad: i.cantidadarticulo ?? i.dCantidadArticulo ?? i.cantidad ?? i.dCantidad ?? 0,
      pmvb: i.pmvb ?? i.dPMVB ?? 0,
      costoventa: i.costoventa ?? i.dCostoVenta ?? 0,
      almacenexhibidor: i.almacenexhibidor || i.sAlmacenExhibidor || almacenDefecto,
    }));

  const handleFlushEntradaRedis = async (pcOverride, opts = {}) => {
    const silent = opts.silent === true;
    const statusActual = (statusEntrada || "").trim().toUpperCase();
    if (statusActual === "TR" || statusActual === "CA") return true;
    if (!listaEntradas || listaEntradas.length === 0) return true;
    if (isNullOrEmpty(almacenExhibidor)) {
      if (!silent) handleOpenAlert("Seleccione un almacén/exhibidor");
      return false;
    }
    const pcGuardar = String(pcOverride || parametrosCajaForm.caja || "").trim().toUpperCase();
    const response = await PostRequest({
      url: apiEntradasGuardarTemporales,
      ...(silent ? {} : { loader: "Finando captura en SQL..." }),
      body: {
        folio: folioEntrada,
        concepto: conceptoEntrada,
        almacenexhibidor: almacenExhibidor,
        pc: pcGuardar,
        usuario: usuario,
        items: mapearItemsFinado(listaEntradas, almacenExhibidor),
      },
    });
    if (response.hasError || response.HasError) {
      if (!silent) handleOpenAlert(response.message || "Error al finar la entrada en SQL");
      return false;
    }
    if (!silent) await handleCargarEntradasRedis(folioEntrada, pcGuardar);
    // Rev 6/7: finado explícito -> EDITAR habilita Aplicar (GUARDAR = pendiente).
    // El autofinado silencioso NO toca el título: si lo pusiera en EDITAR,
    // congelaría lector/buscador/acciones en plena captura.
    if (!silent) setTitleActionSave("EDITAR");
    return true;
  };

  const handleFlushSalidaRedis = async (pcOverride, opts = {}) => {
    const silent = opts.silent === true;
    const statusActual = (statusSalida || "").trim().toUpperCase();
    if (statusActual === "TR" || statusActual === "CA") return true;
    if (!listaSalidas || listaSalidas.length === 0) return true;
    if (isNullOrEmpty(almacenExhibidorSalida)) {
      if (!silent) handleOpenAlert("Seleccione un almacén/exhibidor");
      return false;
    }
    const pcGuardar = String(pcOverride || parametrosCajaForm.caja || "").trim().toUpperCase();
    const response = await PostRequest({
      url: apiSalidasGuardarTemporales,
      ...(silent ? {} : { loader: "Finando captura en SQL..." }),
      body: {
        folio: folioSalida,
        concepto: conceptoSalida,
        almacenexhibidor: almacenExhibidorSalida,
        pc: pcGuardar,
        usuario: usuario,
        items: mapearItemsFinado(listaSalidas, almacenExhibidorSalida),
      },
    });
    if (response.hasError || response.HasError) {
      if (!silent) handleOpenAlert(response.message || "Error al finar la salida en SQL");
      return false;
    }
    if (!silent) await handleCargarSalidasRedis(folioSalida, pcGuardar);
    // Rev 6/7: igual que entradas, solo el finado explícito deja EDITAR.
    if (!silent) setTitleActionSave("EDITAR");
    return true;
  };

  // ─── Rev 6: borrado directo en el buffer Redis ─────────────────────────────
  const eliminarBufferRedis = async (tipo, folio, pc) => {
    try {
      if (!folio) return;
      const url = apiEntradasCapturaEliminarTodo
        .replace("{tipo}", tipo)
        .replace("{folio}", folio)
        .replace("{pc}", encodeURIComponent(String(pc || parametrosCajaForm.caja || "").trim().toUpperCase()));
      await DeleteRequest({ url });
    } catch {}
  };

  const eliminarPartidaBufferRedis = async (tipo, partida) => {
    try {
      const clave = partida?.clavearticulo || partida?.sClaveArticulo || "";
      const medida = partida?.medida ?? partida?.dMedida ?? 0;
      const almacen = partida?.almacenexhibidor || partida?.sAlmacenExhibidor || "";
      const folio = partida?.folioentradasalida ?? partida?.iFolioEntradaSalida
        ?? (tipo === "ENTRADA" ? folioEntrada : folioSalida);
      const pc = String(partida?.pc || parametrosCajaForm.caja || "").trim().toUpperCase();
      if (!clave || !folio) return;
      const url = apiEntradasCapturaEliminarPartida
        .replace("{tipo}", tipo)
        .replace("{folio}", folio)
        .replace("{pc}", encodeURIComponent(pc))
        .replace("{clave}", encodeURIComponent(String(clave).trim()))
        .replace("{medida}", medida)
        .replace("{almacen}", encodeURIComponent(String(almacen).trim()));
      await DeleteRequest({ url });
    } catch {}
  };

  // Lista mezclada SQL + buffer (reemplaza la mezcla con localStorage).
  const sincronizarCabeceroLista = (lista, setListaFn, setStatusFn, setConceptoFn, setAlmacenFn, conceptoActual, almacenActual, mantenerEdicion) => {
    const rows = Array.isArray(lista) ? lista : [];
    setListaFn(rows);
    if (rows.length > 0) {
      const status = String(rows[0]?.statusentradasalida || "").trim().toUpperCase();
      if (rows[0]?.statusentradasalida) setStatusFn(rows[0].statusentradasalida);
      const c = String(rows[0]?.conceptoentradasalida || "").trim();
      if (c && !String(conceptoActual || "").trim()) setConceptoFn(c);
      const a = String(rows[0]?.almacenexhibidor || "").trim();
      if (a && !String(almacenActual || "").trim()) setAlmacenFn(a);
      // TR/CA nunca se editan (igual que la carga SQL clásica).
      setTitleActionSave(status === "TR" || status === "CA" ? "EDITAR" : "GUARDAR");
    } else if (!mantenerEdicion) {
      setTitleActionSave("NUEVA");
    }
  };

  const handleCargarEntradasRedis = async (folio, pcOverride) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;
    const folioUsar = folio || folioEntrada;
    if (!folioUsar) return;
    const pcActual = String(pcOverride || parametrosCajaForm.caja || "").trim().toUpperCase();
    const url = apiEntradasCapturaLista
      .replace("{tipo}", "ENTRADA")
      .replace("{folio}", folioUsar)
      .replace("{pc}", pcActual);
    const response = await GetRequest({ url, loader: "Consultando folio de entrada..." });
    if (response.hasError || response.HasError) {
      setListaEntradas([]);
      return;
    }
    sincronizarCabeceroLista(response.result, setListaEntradas, setStatusEntrada,
      setConceptoEntrada, setAlmacenExhibidor, conceptoEntrada, almacenExhibidor, false);
  };

  const handleCargarSalidasRedis = async (folio, pcOverride) => {
    if (parametrosCajaForm.caja === "CAJA-DEFAULT") return;
    const folioUsar = folio || folioSalida;
    if (!folioUsar) return;
    const pcActual = String(pcOverride || parametrosCajaForm.caja || "").trim().toUpperCase();
    const url = apiEntradasCapturaLista
      .replace("{tipo}", "SALIDA")
      .replace("{folio}", folioUsar)
      .replace("{pc}", pcActual);
    const response = await GetRequest({ url, loader: "Consultando folio de salida..." });
    if (response.hasError || response.HasError) {
      setListaSalidas([]);
      return;
    }
    sincronizarCabeceroLista(response.result, setListaSalidas, setStatusSalida,
      setConceptoSalida, setAlmacenExhibidorSalida, conceptoSalida, almacenExhibidorSalida, false);
  };

  return (
    <InventariosContext.Provider
      value={{
        folioEntrada,
        folioSalida,
        dataEntradas,
        setDataEntradas,
        dataSalidas,
        setDataSalidas,
        articuloEscaneado,
        setArticuloEscaneado,
        handleObtenerDatosEntradas,
        handleCargarDatosEntradaOtraPC,
        handleCargarEntradas,
        handleCargarSalidas,
        handleCargarSalidasOtraPC,
        handleObtenerDatosSalidas,
        listaEntradas,
        listaSalidas,
        listaEntradasSalidas,
        handleObtenerConceptosEntradas,
        handleObtenerConceptosSalidas,
        listaConceptosEntrada,
        listaConceptosSalida,
        listaAlmacenesExhibidoresEntrada,
        listaAlmacenesExhibidoresSalida,
        listaAlmacenesExhibidoresGeneral,
        openModalImpresionEntradasSalidas,
        setOpenModalImpresionEntradasSalidas,
        handleCargarEscaneosFromFile,
        handleObtenerAlmacenesExhibidores,
        totalPMVB,
        totalCostoVenta,
        totalVentaNeta,
        totalRegistros,
        cantidadArticulos,
        statusEntrada,
        statusSalida,
        handleRegistrarArticuloEntrada,
        // Rev 3 (23/09/2026): flujo Redis (catálogo + buffer, vía RequestContext/JWE)
        catalogoCbarrasInfo,
        handleCargarCatalogoCbarras,
        resolverArticuloCbarrasLocal,
        handleResolverCodigoEntradas,
        handleResolverCodigoSalidas,
        handleCapturarEntradaRedis,
        handleCapturarSalidaRedis,
        handleFlushEntradaRedis,
        handleFlushSalidaRedis,
        handleCargarEntradasRedis,
        handleCargarSalidasRedis,
        statusModalBuscadorArticulos,
        setStatusModalBuscadorArticulos,
        handleBuscarArticuloDescripcion,
        handleCloseBuscarArticuloDescripcion,
        handleCloseBuscarArticuloDescripcionTomaInventario,
        conceptoEntrada,
        handleChangeConcepto,
        conceptoSalida,
        handleChangeConceptoSalida,
        handleChangeAlmacenexhibidor,
        almacenExhibidor,
        setAlmacenExhibidor,
        handleChangeAlmacenexhibidorSalida,
        almacenExhibidorSalida,
        setAlmacenExhibidorSalida,
        handleClickRegresarMainDashboard,
        handleObtenerFolioEntradaDisponible,
        handleClickNuevaEntrada,
        handleClickGuaredarEntrada,
        handleGuardarEntrada,
        hendleEliminarPartidaEntradaSalida,
        hendleEliminarEntradaSalida,
        handleActualizarCantidadPartidaEntrada,
        handleGuardarSalida,
        handleActualizarCantidadPartidaSalida,
        handleEliminarDataEntrada,
        handleEliminarDataSalida,
        handleObtenerArticuloDataFull,
        handleImprimirEntrada,
        handleImprimirEntradaMenu,
        handleCerrarImprimirEntrada,
        reactToPrintFn,
        setOpenModal,
        openModal,
        pdfUrl,
        handleAplicarEntrada,
        handleCancelarEntrada,
        titleActionSave,
        setTitleActionSave,
        handleClickNuevaGuardarEntrada,
        handleClickEditarGuardarEntrada,
        handleClickNuevaEntradaButton,
        openModarlBuscarEntradaSalida,
        handleCloseModarBuscarEntradaSalida,
        handleOpenModalBuscarEntradaSalida,
        setOpenModarlBuscarEntradaSalida,
        handleImprimirSalida,
        handleAplicarSalida,
        handleCancelarSalida,
        handleClickNuevaGuardarSalida,
        handleClickEditarGuardarSalida,
        handleClickNuevaSalidaButton,
        handleClickNuevaSalida,
        handleObtenerFolioSalidaDisponible,
        handleRegistrarArticuloSalida,
        setVentanaAbierta,
        ventanaAbierta,
        handleObtenerExistenciasAlmacenExhibidor,
        dataFiltroExistencias,
        listaExistencias,
        handleObtenerKardexArticulo,
        claveArticulo,
        medida,
        setClaveArticulo,
        setMedida,
        statusWaiting,
        setStatusWaiting,

        //Traslados
        errorDestino,
        setErrorDestino,
        listaTrasladosData,
        setListaTrasladosData,
        handleCargarTrasladosPC,
        almacenExhibidorOrigen,
        almacenExhibidorDestino,
        setAlmacenExhibidorOrigen,
        setAlmacenExhibidorDestino,
        handleRegistrarTrasladosPC,
        handleClickDeletePartida,
        handleClickDeleteTraslado,
        handleClickNuevoTraslado,
        isTrasladoBlocked,
        setIsTrasladoBlocked,
        partidaTrasladoSeleccionada,
        setPartidaTrasladoSeleccionada,
        handleAplicarTrasladoPC,
        handleImprimirTraslado,
        handleImprimirTrasladoHistorialDia,
        handleCloseModalBuscarArticulos,
        openModalBuscarArticulos,
        setOpenModalBuscarArticulos,
        handleAbrirModalBuscarArticulos,
        handleBuscarArticuloFullData,
        setDataFiltroExistencias,
        openModalAlertaSinExistencia,
        setOpenModalAlertaSinExistencia,
        dataArticuloSinExistencia,
        setDataArticuloSinExistencia,
        //Etiquetado
        dataArticuloEtiquetar,
        setDataArticuloEtiquetar,
        medidaEtiqueta,
        setMedidaEtiqueta,
        articuloFiltro,
        setArticuloFiltro,
        articuloEtiquetar,
        setArticuloEtiquetar,
        dataArticuloFiltroEtiquetado,
        setDataArticuloFiltroEtiquetado,
        handleClickNuevoEtiquetado,
        handleCancelarEtiquetado,
        handleEliminaPartidaEtiquetado,
        handleEliminaEtiquetadoCompleto,
        handleImprimirEtiquetas,
        handleChangeRowFiltroEtiquetar,
        handleChangeRowEtiquetar,
        handleObtenerExistenciasAlmacenExhibidorEtiquetado,
        handleAgregarAEtiquetado,
        cantidadesEtiquetado,
        setCantidadesEtiquetado,
        handleChangeCantidadEtiquetado,
        integrarInventario,
        setIntegrarInventario,
        handleGetListEtiqetado,
        handleCambiarAlmacenEtiquetado,
        setAlmacenExhibidorEtiquetado,
        statusEnableFieldsEtiquetado,
        setStatusEnableFieldsEtiquetado,
        openModalConfirmIntegrar,
        setOpenModalConfirmIntegrar,
        handleOpenModalConfirmIntegrar,
        handleCloseModalConfirmIntegrar,
        handleConfirmIntegrarInventario,
        openModalConfirmSoloEtiquetado,
        setOpenModalConfirmSoloEtiquetado,
        handleOpenModalConfirmSoloEtiquetado,
        handleCloseModalConfirmSoloEtiquetado,
        handleConfirmSoloEtiquetado,
        ejecutarImpresionYIntegracion,
        estadoImpresoraEtiqueta,
        setEstadoImpresoraEtiqueta,
        validarImpresoraEtiqueta,
        impresoraAlternativaEtiqueta,
        setImpresoraAlternativaEtiqueta,
        obtenerImpresoraEfectivaEtiqueta,
        listaImpresorasEtiqueta,
        cargarListaImpresorasEtiqueta,
        estadoPrinterTools,
        setEstadoPrinterTools,
        validarConexionPrinterTools,

        // Toma Inventario
        statusModalBuscadorArticulosTomaInventario,
        setStatusModalBuscadorArticulosTomaInventario,
        tomaHeader,
        setTomaHeader,
        tomaDetalle,
        setTomaDetalle,
        tomaZonasDiff,
        setTomaZonasDiff,

        // Paginación detalle Toma Inventario
        tomaDetallePage,
        setTomaDetallePage,
        tomaDetallePageSize,
        tomaDetalleTotalCount,
        tomaDetalleTotalPages,
        handleTomaLoadDetalles,
        handleTomaChangePage,
        handleTomaChangePageSize,
        handleTomaFilter,

        openModalTomaSelectivo,
        setOpenModalTomaSelectivo,
        openModalTomaImportar,
        setOpenModalTomaImportar,
        openModalTomaZonasDiff,
        setOpenModalTomaZonasDiff,

        tomaBuscadorQ,
        setTomaBuscadorQ,
        tomaArticulosFound,
        setTomaArticulosFound,

        handleTomaReset,
        handleTomaCargarActivo,
        handleTomaLoadAll,
        handleTomaCrearFolio,
        handleTomaGuardarHeader,
        handleTomaCargarArticulos,
        handleTomaBuscarArticulos,
        handleTomaAgregarArticuloSelectivo,
        handleTomaGuardarDetalle,
        handleTomaActualizarConteoAFijar,
        handleTomaEliminarArticulo,
        handleTomaEliminarTodo,
        handleTomaImportarConteos,
        handleTomaValidarZonas,
        handleTomaFijarConteoPorRegla,
        handleTomaFijarTodoConteo,
        handleTomaReiniciarConteos,
        handleTomaReiniciarConteoArticulo,
        handleTomaEditarConteo3,
        handleTomaEliminarConteosEscaneo,
        handleTomaImportarConteosAConteosEscaneo,
        handleTomaCerrarInventario,
        handleTomaAplicarInventario,
        handleTomaCancelarInventario,
        handleTomaImprimirPdf,
        handleTomaBuscarYAgregarPorCodigoBarras,

        handleArticuloSeleccionado,
        openModalFirmaTraslados,
        handleCerrarFirmaTraslados,
        handleAbrirFirmaTraslados,
        openModalValidarAcceso,
        handleAbrirValidarAccesoTraslados,
        handleCerrarValidarAccesoTraslados,
        handleEjecutarTrasladoValidado,
        handleDarIngresoRapido,
        handleSincronizarExistenciasEntradas,
        handleSincronizarExistenciasFiltradas,
        handleSincronizarExistenciaArticulo,
      }}
    >
      {props.children}
    </InventariosContext.Provider>
  );
};

export const useInventarios = () => useContext(InventariosContext);
